import React, { Component } from "react";
import { Box, Select, MenuItem, FormControl, InputLabel, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, FormHelperText,Menu, CircularProgress, Snackbar, Alert, Checkbox } from "@mui/material";
import Navigationbar from '../Navigationbar';
import globalVariables from "../../custom_libraries/globalVariables";
import urls from '../../custom_libraries/urls';
import { get, post, getFreshToken, put, del} from '../../custom_libraries/serverRequests';
import { Chip } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import { Switch, FormControlLabel } from "@mui/material";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BlockIcon from '@mui/icons-material/Block';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import DeviceIcon from '../../assets/icons8-bullet-camera-gray-24 .png'
import withNavigate from "../../Global_files/WithNavigate";

// import CarIcon from '../../assets/icons8-car-30.png';
// import personIcon from '../../assets/icons8-person-48.png';
// import motorIcon from '../../assets/icons8-bike-50.png';
import TwoWheelerRounded from '@mui/icons-material/TwoWheelerRounded';
import DirectionsCarFilledRounded from '@mui/icons-material/DirectionsCarFilledRounded';
import DirectionsWalkRounded from '@mui/icons-material/DirectionsWalkRounded';
import InternetConnectionDetector from "../../Global_files/InternetConnectionDetector";
import './AlertTab.css';
// import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import Badge from "@mui/material/Badge";
// import CrisisAlertIcon from "@mui/icons-material/WarningAmber";
import sirenStrobeIconRed from '../../assets/icons8-siren-48_red.png';
import sirenStrobeIconGreen from '../../assets/icons8-siren-48_green.png';
// import { alertsDB } from "../../db/alertsDB";
import Popover from "@mui/material/Popover";
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
// import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
// import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
// import VoiceChatIcon from '@mui/icons-material/VoiceChat';
import MicIcon from '@mui/icons-material/Mic';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import StreetviewIcon from '@mui/icons-material/Streetview';
import PlaceIcon from '@mui/icons-material/Place';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------
class AlertTab extends Component {

    constructor(props) {
        super(props);
        this.snoozeIntervals = {}; // instance variable, NOT state
        this.ws = null;
        this.reconnectTimer = null;
        this.audioRef = React.createRef();
        this.liveStreamRef = React.createRef();
        this.dragHandleRef = React.createRef();
        this.state = {
            groups: "",
            site: "",
            device: "",
            camera: "",
            sitename: "",
            selected_sites: [], // stores selected sites
            selected_devices: [], // Tracks the selected devices for the site
            selected_cameras: [],
            site_list: [],
            devices: [], // State to store devices
            cameras: [], // Will store cameras from ALL selected devices
            devicename: '',
            siteId: null,
            deviceId: null,
            cameraId: null,
            groups_list: [],
            groupname: '',
            groupId: null,
            selectedRating: null,
            startDate: "",  // from date
            endDate: "",    // to date
            startTime: "",
            endTime: "",
            openStartTime: false,
            openEndTime: false,

            tempHour: "",
            tempMinute: "",
            tempPeriod: "",
            dateError: "", // for date validation error
            todayDate: "", // To store today's date
            showLiveStream: false,
            alerts: [],
            filteredAlerts: [],
            apiFilteredAlerts: [],
            selectedVideoUrl: null,
            selectedAlertId: null,  // 🆕 track which row/video is selected
            selectedAlert: null,
            isPolling: false,
            //pollingIntervalId: null,
            isRefreshing: false, // Spinner control
            //Notes 
             showNoteDialog: false,
             noteText: "",
            noteDetails: {
             siteName: "",
                cameraName: "",
                outcome: "",
            },
            //Filter By Resolve and Detection
            resolveStatus: "", // New Filter 1
            detectionType: "All",    // New Filter 2
            anchorElResolve: null,         // ⬇️ dropdown anchors
            anchorElDetection: null,
            showResolveOptions: false,
            showDetectionOptions: false,
            showFilterDropdowns: false, // controls visibility of that section
            hasInitialAlertSelected: false, // new flag
            //Pagination
            videoAlertPage: 1,
            videoAlertTotalPages: 1,
            pageSize: 25,
            //AutoReload
            // autoRefreshEnabled: true, // default: ON
            // pollingIntervalId: null,
            // activeTab: "alerts", // or whatever your default is
          detectionTypeColors :{
            Car: '#80c4ff',    // Vehicle
            Bike: '#e84bff',   // Bike
            Person: '#52f55d', // Intruder
            All: '#f58152',    // All Detection Types
          },
          noteHistory: [],
          showNoteHistoryDialog: false,

          snackbar_msg: '',
          open_snackbar: false,
          selectedCamId: null, // 🆕 store cam_id for live stream
          lastAlertTimestamp: null, // 🆕 store last alert timestamp
          whatTimeAgo:null,

          snoozeTimer: null,        // formatted countdown "04:59"
          snoozeIntervalId: null,   // interval reference
          snoozedCameraId: null,    // which camera is snoozed
          snoozeTimers: {},
          selectedSnoozeMinutes: 0, //taking user input for snooze duration, by default value is 0 mins

          Snoozed_by : null,
          Snooze_time : null,
          // ---pop-up notifications--
          wsAlerts: [],          // all alerts received from websocket
          totalWsAlertCount: 0,  // derived count
          showWsAlertTable: false,
          userId: null,
          selectedRatingOption: null,
          audioEnabled: false,
          selectedAudio: "",
          audioList: [
            { name: "Emergency Alert.mp3", id: "6" },
          ],
          isAudioPlaying: false,

          fetchedCamerasList: [], // List of cameras for the selection box
          selectedLiveCameras: [], // Array of camera objects currently being streamed
          isFullScreen: false,     // Full screen toggle
          focusedCamera: null,     // Which camera is focused in full screen
          pendingNotifications: [],
          notificationQueue: [],
          failedStreams: {}, // to store the camera IDs that have failed to stream
          open_progress_bar: false,
        };
        this.isShowingNotification = false;
        this.notificationTimer = null;
        this.recentAlerts = {};
        this.notificationCooldown = null;
    }

    // handleSiteSelectionChange = (event) => {
    //     const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);

    //     // Get selected site objects
    //     const selectedSites = this.state.site_list.filter(site => selectedOptions.includes(site.id));

    //     // Get all devices that belong to the selected sites
    //     const filteredDevices = this.state.devices.filter(device =>
    //         selectedOptions.includes(device.site_id) // Make sure you use the correct field name here
    //     );
    //     const filteredDeviceIds = filteredDevices.map(device => device.id);

    //     // Get all cameras that belong to those filtered devices
    //     const filteredCameras = this.state.cameras.filter(camera =>
    //         filteredDeviceIds.includes(camera.device_id)
    //     );
    //     const filteredCameraIds = filteredCameras.map(camera => camera.id);

    //     // Filter currently selected devices and cameras to only those that still belong to selected sites
    //     const validSelectedDevices = this.state.selected_devices.filter(deviceId =>
    //         filteredDeviceIds.includes(deviceId)
    //     );
    //     const validSelectedCameras = this.state.selected_cameras.filter(cameraId =>
    //         filteredCameraIds.includes(cameraId)
    //     );

    //     this.setState({
    //         selected_sites: selectedSites,
    //         selected_devices: validSelectedDevices,
    //         selected_cameras: validSelectedCameras
    //     });
    // };

    // handleDeviceChange = (selectedDevices) => {
    //     const newSelectedDevices = selectedDevices;

    //     const filteredCameras = this.state.cameras.filter(camera =>
    //         newSelectedDevices.includes(camera.deviceId)
    //     );
    //     const filteredCameraIds = filteredCameras.map(c => c.id);

    //     this.setState((prevState) => ({
    //         selected_devices: newSelectedDevices,
    //         selected_cameras: prevState.selected_cameras.filter(c => filteredCameraIds.includes(c))
    //     }));
    // }


    // handleChange = (event) => {
    //     this.setState({ [event.target.name]: event.target.value }, () => {
    //         // Fetch devices if site is selected
    //         if (event.target.name === "site") {
    //             this.getDevicesListById(event.target.value);
    //         }
    //     });
    // };

  convertTo12Hour = (time24) => {
    if (!time24) return "";

    const [hour, minute] = time24.split(":");
    let h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12;
    h = h ? h : 12;

    return `${String(h).padStart(2, "0")}:${minute} ${ampm}`;
  };

async componentDidMount() {
  setTimeout(() => {
      this.validateSignedIn();
    }, 0);

  this.setState({ userId : localStorage.getItem(globalVariables.USER_ID) });
  this.connect();
  this.getSitesList();
  // this.getGroupsList();  //-- groups data is not required yet, hence commented out.
  this.fetchDevicesForSelectedSites();
  this.restoreAllSnoozeTimers();  //Restoring ALL Snoozes timer On Page Refresh
  await Promise.all([
    this.getInactiveDeviceNotificationList(),
    this.fetchOfflineCameras(),
  ]);
  
  window.addEventListener('mousemove', this.handleDragMove);
  window.addEventListener('mouseup', this.handleDragEnd);
  window.addEventListener("beforeunload", this.handleBeforeUnload); // Adding this listener to close the live stream pop-up on reload as well.
  window.addEventListener("keydown", this.handleEsc);
  //--------------------------------------------------------------------
    // Check if any stream needs to be stopped (from previous reload)
  const camToStop = localStorage.getItem("stopStreamOnLoad");
  if (camToStop) {
    console.log("Found stream to stop after reload:", camToStop);

    // Direct fetch (no auth needed)
    const stopUrl = urls.STOP_LIVE_STREAM(camToStop);
    fetch(stopUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then(() => {
        console.log("✅ Stream stopped successfully after reload");
        localStorage.removeItem("stopStreamOnLoad");
      })
      .catch((err) => {
        console.error(" Failed to stop stream after reload:", err);
        localStorage.removeItem("stopStreamOnLoad");
      });
  }
    //--------------------------------------------------------------------
    const today = new Date().toISOString().split('T')[0];
    this.setState({ todayDate: today, activeTab: "alerts"}, () => {
      if (this.isFilterInactive()) {
        this.setState({ autoRefreshEnabled: true }, this.startAutoRefreshPolling);
      }
    });
    // Cleanup for notification cooldown if component unmounts
    if (this.notificationCooldown) {
    clearTimeout(this.notificationCooldown);
  }
    //-------------fetch the alerts (per logged in user) from frontend's local DB (IndexDB)-----------
      // const userId = localStorage.getItem(globalVariables.USER_ID);

      // if (!userId) {
      //   console.warn("--- userId not found, skipping IndexedDB fetch");
      //   return;
      // }

      // const userAlerts = await alertsDB.alerts
      //   .where("userId")
      //   .equals(userId)
      //   .toArray();
      
      // console.log("----- Alerts fetched from IndexedDB:---", {
      //   userId,
      //   count: userAlerts.length,
      //   data: userAlerts,
      // });

      // this.setState({
      //   wsAlerts: userAlerts,
      //   totalWsAlertCount: userAlerts.length,
      // });

      // if (userAlerts.length === 0) {
      //   // this.getInactiveDeviceNotificationList();
        
      // }
    //------------------------------------------------------------------------------------------------
}

handleBeforeUnload = () => {
  const { showLiveStream, selectedCamId } = this.state;

  if (showLiveStream && selectedCamId) {
    console.log(" Saving active camera ID before reload:", selectedCamId);
    localStorage.setItem("stopStreamOnLoad", selectedCamId);
  }
};


videoRef = React.createRef();

componentDidUpdate(prevProps, prevState) {
  if (
    prevState.selectedVideoUrl !== this.state.selectedVideoUrl &&
    this.state.selectedVideoUrl &&
    this.videoRef.current
  ) {
    console.log("🎬 Video URL changed, loading...");

    const video = this.videoRef.current;
    video.pause();
    video.load();

    const tryPlay = () => {
      video
        .play()
        .then(() => console.log("✅ Video playing"))
        .catch((err) => {
          console.error("🚫 Autoplay failed:", err);
        });
    };

    // Wait until metadata is loaded before trying to play
    video.onloadeddata = () => {
      console.log("📦 Metadata loaded. Playing now...");
      tryPlay();
    };
  }
  const { tenantId, deviceName } = this.props;
  // Reconnect if tenant/device changes
    if (
      prevProps.tenantId !== tenantId ||
      prevProps.deviceName !== deviceName
    ) {
      this.cleanup();
      this.connect();
    }
}

validateSignedIn = async () => {    //function to validate the tocken expiry of logged in user
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);
      
          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
        }

isFilterInactive = () => {  //function to set the flag of filter applied or not to start/stop auto refresh
  const {
    selected_sites,
    selected_devices,
    selected_cameras,
    startDate,
    endDate,
    resolveStatus,
    detectionType
  } = this.state;

  return (
    selected_sites.length === 0 &&
    selected_devices.length === 0 &&
    selected_cameras.length === 0 &&
    !startDate &&
    !endDate &&
    (resolveStatus === "All" || resolveStatus === "Unresolved" || !resolveStatus) &&
    (detectionType === "All" || !detectionType)
  );
};


startAutoRefreshPolling = () => {   //function to continuously fetch the real time alerts.
  if (this.state.pollingIntervalId) return;

  const intervalId = setInterval(() => {
    const { autoRefreshEnabled, activeTab, endDate, todayDate } = this.state;
    const isEndDateTodayOrEmpty = !endDate || endDate === todayDate;

    if (autoRefreshEnabled && this.state.videoAlertPage === 1 && activeTab === "alerts" && isEndDateTodayOrEmpty) { //disable auto refresh when user is not on page 1
      console.log(" Auto-refreshing alerts (endDate is today or empty)...");
      this.apiFilteredAlerts(1);
    }
  }, 2 * 1000); // every 2 Second // Changed from 5s to 1s and now to 2s for avoiding backend server overload by pending requests

  this.setState({ pollingIntervalId: intervalId });

  // Trigger immediate fetch
  const { autoRefreshEnabled, activeTab, endDate, todayDate } = this.state;
  const isEndDateTodayOrEmpty = !endDate || endDate === todayDate;

  if (autoRefreshEnabled && activeTab === "alerts" && isEndDateTodayOrEmpty) {
    console.log(" Immediate auto-refresh fetch (endDate is today or empty)");
    this.apiFilteredAlerts(1);
  }
};



componentWillUnmount() {
  if (this.socket) this.socket.close();
  if (this.state.pollingIntervalId) clearInterval(this.state.pollingIntervalId);

    if (this.state.showLiveStream) {
    this.handleCloseLiveStream();
  }
    window.removeEventListener('mousemove', this.handleDragMove);
    window.removeEventListener('mouseup', this.handleDragEnd);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);     // Remove reload listener
    window.removeEventListener("keydown", this.handleEsc);
    Object.values(this.snoozeIntervals).forEach(clearInterval);
    this.snoozeIntervals = {};
    this.cleanup(); // Clean up resources from websocket and polling
  }


handleDragStart = (e) => {
  // ✅ Only drag when clicking header
  if (this.dragHandleRef && this.dragHandleRef.current && !this.dragHandleRef.current.contains(e.target)) {
    return;
  }
  // ❗ Ignore drag when clicking interactive elements
  if (
    e.target.closest(".MuiFormControl-root") ||
    e.target.closest(".MuiSelect-root") ||
    e.target.closest(".MuiInputBase-root") ||
    e.target.closest("button") ||
    e.target.closest("svg")
  ) {
    return;
  }
  // e.preventDefault(); // ✅ Prevent text selection and dragging glitches
  document.body.style.userSelect = 'none'; // ✅ Block text selection globally

  this.dragStartX = e.clientX;
  this.dragStartY = e.clientY;

  const box = this.liveStreamRef?.current?.getBoundingClientRect();
  if (box) {
    this.setState({
      isDragging: true,
      dragOffsetX: this.dragStartX - box.left,
      dragOffsetY: this.dragStartY - box.top,
    });
  }
};


handleDragMove = (e) => {
  if (!this.state.isDragging) return;

  const newLeft = e.clientX - this.state.dragOffsetX;
  const newTop = e.clientY - this.state.dragOffsetY;

  this.setState({
    liveStreamBoxLeft: `${newLeft}px`,
    liveStreamBoxTop: `${newTop}px`,
  });
};

handleDragEnd = () => {
  document.body.style.userSelect = ''; // ✅ Restore text selection after drag
  this.setState({ isDragging: false });
};


// applyFilters = (alerts) => {
//   const { selected_cameras } = this.state;

//   if (!selected_cameras || selected_cameras.length === 0) {
//     return alerts;
//   }

//   return alerts.filter(alert =>
//     selected_cameras.includes(String(alert.camera_id))
//   );
// }
  // For refreshing alerts for 1 hour 

handleTabChange = (tabName) => { 
  const { pollingIntervalId } = this.state;

  if (tabName !== "alerts") {
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
      this.setState({ pollingIntervalId: null });
      console.log("🛑 Auto-refresh stopped (left Alerts tab)");
    }
    if (this.state.showLiveStream) {
      this.handleCloseLiveStream();
    }
  } else {
    // Only enable if filters are inactive
    if (this.isFilterInactive()) {
      this.setState({ autoRefreshEnabled: true }, () => {
        this.startAutoRefreshPolling();
        console.log("✅ Auto-refresh enabled on Alerts tab with no filters");
      });
    } else {
      this.setState({ autoRefreshEnabled: false });
      console.log("⛔ Filters active — auto-refresh disabled");
    }
  }

  this.setState({ activeTab: tabName });
};


handleApplyFilters = () => {    //function called upon clicking Apply button
  const {
    selected_sites,
    selected_devices,
    selected_cameras,
    startDate,
    endDate,
    startTime,
    endTime,
    pollingIntervalId
  } = this.state;

  const anyFilterSelected =
    selected_sites.length > 0 ||
    selected_devices.length > 0 ||
    selected_cameras.length > 0 ||
    startDate || endDate;

  // Case 3: Filters partially filled — invalid state
  if ((anyFilterSelected) && (!startDate || !endDate)) {
    alert("Please select both Start Date and End Date.");
    return;
  }

  if ((!anyFilterSelected) && (!startDate || !endDate)) {
    console.error('no filter selected, exiting filter application and continuing with live polling');
    this.setState({
        // autoRefreshEnabled: true,
        // pollingIntervalId: null,
        showFilterDropdowns: true,
        hasInitialAlertSelected: false,
        resolveStatus: "Unresolved"
      })
    return;
  }

  const isSameDate = startDate && endDate && startDate === endDate;

  let formattedStartTime = "";
  let formattedEndTime = "";

  if (isSameDate && startTime && endTime) {
    formattedStartTime = this.convertTo12Hour(startTime);
    formattedEndTime = this.convertTo12Hour(endTime);
  }

    // Case 2: No filters and no dates selected — fetch last 1 hour with auto-refresh
    if (!anyFilterSelected) {
      const now = new Date();
      const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
      const formatDate = (dateObj) => {
        return dateObj.toISOString().split('T')[0]; // returns 'yyyy-mm-dd'
      };

      const defaultStartDate = formatDate(oneHourAgo);
      const defaultEndDate = formatDate(now);
      if (pollingIntervalId) clearInterval(pollingIntervalId);

      this.setState({
        // startDate: defaultStartDate,
        // endDate: defaultEndDate,
        autoRefreshEnabled: true,
        pollingIntervalId: null,
        showFilterDropdowns: true,
        hasInitialAlertSelected: false,
        resolveStatus: "Unresolved",
      }, () => {
        this.apiFilteredAlerts("" , "");
        this.startAutoRefreshPolling();
        console.log("✅ Fetching alerts for last 1 hour with auto-refresh.");
      });

      return;
    }

    // Case 3: Filters and full date range selected — disable auto-refresh
    if (pollingIntervalId) clearInterval(pollingIntervalId);

    this.setState({
      autoRefreshEnabled: false,
      pollingIntervalId: null,
      showFilterDropdowns: true,
      hasInitialAlertSelected: false, 
      resolveStatus: "Unresolved",
      videoAlertPage: 1, // ✅ reset to page 1
    }, () => {
      this.apiFilteredAlerts();
      console.log("⛔ Filters applied — Auto-refresh disabled.");
    });
};


// this function is not being used anymore, hence commented out.
    // getGroupsList = async () => {
    //     try {
    //         //   this.startLoading();
    //         let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    //         console.log("--------auth tocken getGroupsList---------", access_tocken);
    //         let headers = {
    //             'content-type': 'application/json',
    //             'Authorization': `Bearer ${access_tocken}`
    //         }

    //         console.log("Fetching data from:", urls.GET_ALL_GROUPS_INCLUDING_SUBGROUPS); // Update URL for fetching sites
    //         const response = await get(urls.GET_ALL_GROUPS_INCLUDING_SUBGROUPS, headers);
    //         console.log("response getGroupsList ===> ", response);
    //         // this.stopLoading();
    //         if (!response) {
    //             console.error("Failed to fetch getGroupsList.");
    //             this.setState({ groups_list: [] });
    //             return;
    //         }

    //         this.setState({ groups_list: response.data });
    //     } catch (error) {
    //         console.error("Error in getGroupsList:", error);
    //         this.setState({ groups_list: [] });
    //     }
    // };

    // Fetch the sites list from the API
    
    getSitesList = async () => {
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
            };

            const response = await get(urls.GET_SITES_BY_USER, headers);
            if (!response) {
                console.error("Failed to fetch site list.");
                this.setState({ site_list: [] });
                return;
            }

            this.setState({ site_list: response.data[0] });
        } catch (error) {
            console.error("Error in getSitesList:", error);
            this.setState({ site_list: [] });
        }
    };


    // Fetch devices list by site ID
    getDevicesListById = async (site_id) => {
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        };

        try {
            const url = urls.GET_DEVICES_BY_SITE(site_id);
            const response = await get(url, headers);
            console.log("getDevicesListById", response);
            if (response.data) {
                return response.data; // ✅ Return device list here
            } else {
                console.error("No data returned from the API");
                return [];
            }
        } catch (error) {
            console.error("Error fetching devices from API:", error);
            return []; // ✅ Return empty array on error
        }
    };

    getCamerasListByDeviceId = async (deviceId) => {  // Fetch cameras list by device ID
        console.log(`Fetching cameras for device ID: ${deviceId}`);  // Debugging log
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
            };

            const url = urls.CAMERAS_BY_DEVICE(deviceId);
            const response = await get(url, headers);
            console.log("Camera response:", response);  // Debugging log

            if (Array.isArray(response.data)) {
                return response.data; // ✅ Return camera list here
            } else {
                console.error("No valid camera data returned.");
                this.setState({ cameras: [] });
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            this.setState({ cameras: [] });
        }
    };

    // handleInputChange = async (e) => { //not used anymore
    //     const { name, value } = e.target;
    //     console.log(`Changing ${name} to ${value}`);  // Debugging log

    //     this.setState({ [name]: value });

    //     if (name === "sitename") {
    //         this.setState({
    //             siteId: value,
    //             devicename: "", // Clear selected device
    //             deviceId: "",   // Reset device ID
    //             cameraId: "",   // Reset camera ID
    //         });
    //         await this.getDevicesListById(value);
    //     }

    //     if (name === "devicename") {
    //         this.setState({ deviceId: value });
    //         await this.getCamerasListByDeviceId(value); // Fetch cameras when device is selected
    //     }

    //     if (name === "cameraName") {
    //         this.setState({ cameraId: value });
    //     }
    // };

    handleDateChange = (event) => { //function to change the selected date from the filter
      const { name, value } = event.target;
      const { startDate, endDate } = this.state;

      // If user changes START DATE
      if (name === "startDate" && endDate && value > endDate) {
        alert("Start date cannot be greater than End date");
        return;
      }

      // If user changes END DATE
      if (name === "endDate" && startDate && value < startDate) {
        alert("End date cannot be less than Start date");     
        return;
      }

      // Clear error and update state
      this.setState({
        [name]: value,
      });
    };

//     //Handle Download Video
//   handleDownloadVideo = () => {
//     const { selectedVideoUrl } = this.state;

//     if (!selectedVideoUrl) {
//         alert("No video selected to download.");
//         return;
//     }

//     // Create a temporary anchor element and trigger download
//     const link = document.createElement("a");
//     link.href = selectedVideoUrl;
//     link.download = "alert_video.mp4"; // You can make this dynamic if needed
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// };

  // Handle Download Video
handleDownloadVideo = async () => {
    const { selectedVideoUrl } = this.state;

    if (!selectedVideoUrl) {
        alert("No video selected to download.");
        return;
    }

    try {
        this.startLoading(); // Start loading spinner
        const response = await fetch(selectedVideoUrl);

        if (!response.ok) {
          this.stopLoading(); // Stop loading spinner
            throw new Error(`Failed to download video: ${response.status}`);
        }

        const blob = await response.blob();

        // Create a temporary local URL for the Blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create temporary download link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "alert_video.mp4";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.stopLoading();

        // Clean up
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        this.stopLoading();
        console.error("Video download failed:", error);
        alert("Failed to download video. Please try again.");
    }
};

startLoading = () => {
    console.log("startloading")

    this.setState({ open_progress_bar: true });
}

stopLoading = () => {
    this.setState({ open_progress_bar: false });
}

  clearFilter = async () => {   //function to clear all the applied filters
           // 🛑 Stop existing polling
  if (this.state.pollingIntervalId) {
    clearInterval(this.state.pollingIntervalId);
  }

    const now = new Date();
    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
    const formatDate = (dateObj) => dateObj.toISOString().split("T")[0];

    // const defaultStartDate = oneHourAgo.toISOString();
    // const defaultEndDate = now.toISOString();
        this.setState({
            groups: "",
            site: "",
            device: "",
            camera: "",
            sitename: "",
            devicename: "",
            cameraName: "",
            startDate: "",   // ✅ Clear the date
            endDate: "",     // ✅ Clear the date
            startTime:"",
            endTime: "",
            dateError: "",
            siteId: null,
            deviceId: null,
            cameraId: null,
            pdf_path: null,
            warning: false,
            warning1: false,
            error: false,
            selected_sites: [], // stores selected sites
            selected_devices: [], // Tracks the selected devices for the site
            selected_cameras: [],
            site_list: [],
            devices: [], // State to store devices
            cameras: [], // Will store cameras from ALL selected devices
            apiFilteredAlerts: [],
            filteredAlerts: [],
            isRefreshing: false,  // also reset spinner
            showFilterDropdowns: false, // 🔴 hide section
            selectedVideoUrl: null,
            selectedAlert: null,
            selectedAlertId: null,
            pollingIntervalId: null, 
            autoRefreshEnabled: true, // ✅ Enable auto-refresh again
            videoAlertPage: 1,         // ✅ Reset to page 1
            videoAlertTotalPages: 1,   // (optional) reset total page count
            pageSize: 25, 
            resolveStatus: "",
            hasInitialAlertSelected: false,  
        });
        setTimeout(() => {    
        this.getSitesList();
        // this.getGroupsList();  //-- this function is no more getting called (as it is already commented out).
        this.fetchDevicesForSelectedSites();
          if (this.state.activeTab === "alerts") {
      console.log("✅ Auto-refresh re-enabled after clearing filters");
      this.startAutoRefreshPolling();
      this.apiFilteredAlerts();
    }
        }, 500);
    }

    handleMultiSiteChange = (event) => {
        const {
            target: { value },
        } = event;

        // Update selected_sites to be an array of selected site IDs
        this.setState(
            {
                selected_sites: typeof value === 'string' ? value.split(',') : value,
            },
            () => {
                // After updating selected_sites, fetch devices based on the selected sites
                this.fetchDevicesForSelectedSites();
            }
        );
    };

    fetchDevicesForSelectedSites = async () => { //function to fetch the device list w.r.t selected site in the filter
        const { selected_sites } = this.state;
        let allDevices = [];

        for (let siteId of selected_sites) {
            try {
                const siteDevices = await this.getDevicesListById(siteId);
                const rtspSiteDevices = await this.getRtspCamerasDevicesListBySiteId(siteId);
                allDevices = [...allDevices, ...siteDevices, ...rtspSiteDevices];
                console.log(`Fetched ${siteDevices.length + rtspSiteDevices.length} devices for site ${siteId}, all devices:`, allDevices);
            } catch (error) {
                console.error(`Error fetching devices for site ${siteId}:`, error);
            }
        }

        this.setState({ devices: allDevices });
    };

      getRtspCamerasDevicesListBySiteId = async (siteId) => {   //function to fetch the RTSP device list w.r.t selected site in the filter
        try {
          // this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }
          const response = await get(urls.GET_DEVICES_OF_SEPARATE_RTSP_CAMERAS(siteId), headers); //  API call to get the rtsp camera's sites(devices) list w.r.t selected group
          // this.stopLoading();
          console.log("API Response:---getRtspCamerasDevicesListBySiteId---------------------------------------->>>", response.data)
    
          if (response.data) {
            // const rtsp_cameras_device_list = response.data;
            this.setState({ loading: false});
            return response.data;
          }
          else {
                console.error("No data returned from the API");
                return [];
            }
        } catch (error) {
          console.error("Error fetching devices from API:", error);
        }
      };


    fetchCamerasForSelectedDevices = async () => {    //Get the camera list of selected device in the filter
        const { selected_devices } = this.state;
        let allCameras = [];

        for (let deviceId of selected_devices) {
            try {
                const cameras = await this.getCamerasListByDeviceId(deviceId);
                allCameras = [...allCameras, ...cameras];
            } catch (error) {
                console.error(`Error fetching cameras for device ${deviceId}:`, error);
            }
        }

        this.setState({ cameras: allCameras });
    };

    /*-------To Handle Selected Site Device and Camera to unselect it by clicking on cross mark---------*/


    handleDeleteSite = async (siteIdToRemove) => {
        const { selected_sites, selected_devices, selected_cameras } = this.state;

        // 1. Remove site from selected_sites
        const updatedSelectedSites = selected_sites.filter(siteId => siteId !== siteIdToRemove);

        // 2. Fetch devices in parallel
        const deviceFetchPromises = updatedSelectedSites.map(siteId =>
            this.getDevicesListById(siteId)
        );
        const deviceResults = await Promise.all(deviceFetchPromises);
        const newDevices = deviceResults.flat(); // Flatten array of arrays
        const newDeviceIds = newDevices.map(d => d.id);

        // 3. Filter selected devices that are still valid
        const filteredSelectedDevices = selected_devices.filter(deviceId =>
            newDeviceIds.includes(deviceId)
        );

        // 4. Fetch cameras in parallel
        const cameraFetchPromises = filteredSelectedDevices.map(deviceId =>
            this.getCamerasListByDeviceId(deviceId)
        );
        const cameraResults = await Promise.all(cameraFetchPromises);
        const newCameras = cameraResults.flat();
        const newCameraIds = newCameras.map(c => c.id);

        // 5. Filter selected cameras
        const filteredSelectedCameras = selected_cameras.filter(cameraId =>
            newCameraIds.includes(cameraId)
        );

        // 6. Update the state
        this.setState({
            selected_sites: updatedSelectedSites,
            devices: newDevices,
            selected_devices: filteredSelectedDevices,
            cameras: newCameras,
            selected_cameras: filteredSelectedCameras,
        });
    };


    handleDeleteDevice = async (deviceIdToRemove) => {
        const { selected_devices, selected_cameras } = this.state;

        // 1. Remove the device from selected_devices
        const updatedSelectedDevices = selected_devices.filter(deviceId => deviceId !== deviceIdToRemove);

        // 2. Fetch cameras for the remaining selected devices in parallel
        const cameraFetchPromises = updatedSelectedDevices.map(deviceId =>
            this.getCamerasListByDeviceId(deviceId)
        );
        const cameraResults = await Promise.all(cameraFetchPromises);
        const newCameras = cameraResults.flat(); // Flatten array of camera lists
        const newCameraIds = newCameras.map(camera => camera.id);

        // 3. Filter selected cameras that are still valid (exist in newCameraIds)
        const filteredSelectedCameras = selected_cameras.filter(cameraId =>
            newCameraIds.includes(cameraId)
        );

        // 4. Update the state with the filtered devices and cameras
        this.setState({
            selected_devices: updatedSelectedDevices,
            cameras: newCameras,
            selected_cameras: filteredSelectedCameras,
        });
    };


    handleDeleteCamera = (cameraId) => {
        this.setState((prevState) => ({
            selected_cameras: prevState.selected_cameras.filter(id => id !== cameraId)  // Remove the camera from selected_cameras
        }));
    };

    //Rating Button True Threat, Non True Threat , False

    handleRatingClick = (rating) => {
        this.setState({ selectedRating: rating });
    };

    //Video Streaming
    handleViewLiveStream = () => {
        this.setState({ showLiveStream: true });
    };

handleCloseLiveStream = async () => {

  const removedStreamIds = this.state.selectedLiveCameras.map(
    (cam) => String(cam.selectedAlertId)
  );

  console.log("Cameras to stop streaming:", removedStreamIds);

  if (removedStreamIds.length > 0) {
    await this.stopLiveStream(removedStreamIds);
  }

  this.setState({
    showLiveStream: false,
    selectedLiveCameras: [],
    failedStreams: {} // Reseting ALL: Clears all failure statuses when stream layout closes
  });
};
//     handleCloseLiveStream = async () => {
//     // Stop every selected camera session on the server
//     const stopPromises = this.state.selectedLiveCameras.map(cam => 
//         fetch(urls.STOP_LIVE_STREAM(cam.camera_id), { // or use alertId if your API requires it
//             method: "POST",
//             headers: { "Content-Type": "application/json" }
//         })
//     );

//     await Promise.all(stopPromises);
//     // const text = await stopPromises.text(); // log raw response
//     // console.log("🛑 Stop stream response:", stopPromises.status, text);

//     // if (!stopPromises.ok) {
//     //   throw new Error("Stream stop failed");
//     // }

//     this.setState({ 
//         showLiveStream: false, 
//         selectedLiveCameras: [],
//         isFullScreen: false 
//     });
// };

getThreatParam = () => {
  const { selectedRatingOption } = this.state;

  if (!selectedRatingOption) return null;

  switch (selectedRatingOption) {
    case "trueThreat":
      return "True";
    case "trueNonThreat":
      return "trueNonThreat";
    case "false":
      return "false";
    default:
      return null;
  }
};

apiFilteredAlerts = async (page = this.state.videoAlertPage || 1) => {  //function to fetch the alerts based on applied filters.
  const {
    selected_sites,
    selected_devices,
    selected_cameras,
    startDate,
    endDate,
    startTime,
    endTime,
    resolveStatus,
    detectionType
  } = this.state;

const isSameDate = startDate && endDate && startDate === endDate;

let formattedStartTime = "";
let formattedEndTime = "";

if (isSameDate && startTime && endTime) {

  // IMPORTANT: If already contains AM/PM, DO NOT convert again
  if (startTime.includes("AM") || startTime.includes("PM")) {
    formattedStartTime = startTime;
  } else {
    formattedStartTime = this.convertTo12Hour(startTime);
  }

  if (endTime.includes("AM") || endTime.includes("PM")) {
    formattedEndTime = endTime;
  } else {
    formattedEndTime = this.convertTo12Hour(endTime);
  }
}


  // Validate date range if any filter is selected
  const anyFilterSelected =
    selected_sites.length > 0 ||
    selected_devices.length > 0 ||
    selected_cameras.length > 0;

  if ((anyFilterSelected || startDate || endDate) && (!startDate || !endDate)) {
 //   alert("Please select both Start Date and End Date.");
    return;
  }

  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  let queryParams = [];


 if (selected_sites.length > 0) {
  selected_sites.forEach(siteId => queryParams.push(`site_id=${siteId}`));
}

if (selected_devices.length > 0) {
  selected_devices.forEach(deviceId => queryParams.push(`device_id=${deviceId}`));
}

if (selected_cameras.length > 0) {
  selected_cameras.forEach(cameraId => queryParams.push(`camera_id=${cameraId}`));
}

  if (startDate) {
    queryParams.push(`start_date=${startDate}`);
  }

  if (endDate) {
    queryParams.push(`end_date=${endDate}`);
  }

  if (formattedStartTime && formattedEndTime) {
  queryParams.push(`start_time=${encodeURIComponent(formattedStartTime)}`);
  queryParams.push(`end_time=${encodeURIComponent(formattedEndTime)}`);
}


  // ✅ Include resolution_status only if not "All"
  if (resolveStatus && resolveStatus.toLowerCase() !== "all") {
    queryParams.push(`resolution_status=${resolveStatus.toLowerCase()}`);
  }

  // ✅ Include detected_objects only if not "All"
  if (detectionType && detectionType.toLowerCase() !== "all") {
    // queryParams.push(`detected_objects=${detectionType.toLowerCase()}`);
    queryParams.push(
    `detected_objects__contains=${detectionType.toLowerCase()}`
  );
  }

      const threatParam = this.getThreatParam();
    if (threatParam) {
      queryParams.push(`threats=${threatParam}`);
    }

  // ✅ Add page parameter
  queryParams.push(`page=${page}`);
  queryParams.push(`page_size=${this.state.pageSize}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  console.log("📡 Calling API with filters:");
console.log({
  selected_sites,
  selected_devices,
  selected_cameras,
  startDate,
  endDate,
  resolveStatus,
  detectionType,
});
  const url = `${urls.BASE_URL}/api/alerts/video-analytics/filter/${queryString}`;

  console.log("📡 Fetching alerts from server...");
  console.log("🌐 URL:", url);
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error(`Failed to fetch alerts: ${response.status}`);

    const data = await response.json();
   const alerts = Array.isArray(data.results) ? data.results : data.alerts || [];
   this.setState({ lastAlertTimestamp: data.last_alert_time,  whatTimeAgo: data.last_alert_since });

const enrichedAlerts = alerts.map((alert) => ({ 
  ...alert,
  camera_name: alert.camera_name || `Camera ${alert.camera_id}`,
  device_name: alert.device_name || `Device ${alert.device_id}`,
}));
console.log("📦 Video Alert API Response:", data);
console.log("✅ Setting enrichedAlerts:", enrichedAlerts.length, enrichedAlerts);

const firstAlert = enrichedAlerts[0];

const update = {
  apiFilteredAlerts: enrichedAlerts,
  filteredAlerts: [],
  videoAlertPage: page,
  videoAlertTotalPages: Math.ceil(data.count / this.state.pageSize) || 1,
  totalAlertCount: data.count, // ✅ Add this line
};
if (enrichedAlerts.length === 0) {
  update.selectedAlert = null;
  update.selectedAlertId = null;
  update.selectedVideoUrl = null;
  update.selectedRating = "";
  update.hasInitialAlertSelected = false;
}
else if (!this.state.hasInitialAlertSelected && firstAlert) {
  update.selectedAlert = firstAlert;
  update.selectedAlertId = firstAlert.id;
  update.selectedVideoUrl = firstAlert.presigned_url || null;
  update.selectedRating = firstAlert?.threats === "true" ? "trueThreat"
                        : firstAlert?.threats === "truenonthreat" ? "trueNonThreat"
                        : firstAlert?.threats === "false" ? "false"
                        : "";
  update.hasInitialAlertSelected = true; // ✅ prevent future auto-selection
}

this.setState(update);



  } catch (error) {
    console.error("Error fetching filtered alerts:", error);
  } finally {
    this.setState({ isRefreshing: false });
  }
};



// Update alert Status/rating
updateThreatStatus = async (threatValue, useGet = false) => {
  const { selectedAlert, apiFilteredAlerts, resolveStatus } = this.state;
  if (!selectedAlert || !selectedAlert.id) {
    this.openSnackbar("No alert selected.", "warning");
    return;
  }

  const alertId = selectedAlert.id;
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

  try {
    let url, options;

    if (useGet) {
      url = urls.GET_ALERT_THREAT(alertId, threatValue);
      options = {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      };
    } else {
      url = urls.POST_UPDATE_ALERT_THREAT;
      options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: alertId,
          threats: threatValue,
          resolved_dt: new Date().toISOString(), // send to backend
        }),
      };
    }

    const response = await fetch(url, options);
    if (!response.ok) throw new Error("Failed to update threat status");

    // 🔹 Parse API response (contains new_threats & resolved_dt)
    const responseData = await response.json();
    console.log("Threat Update Response:", responseData);

    const updatedThreat = responseData.new_threats || threatValue;
    const resolvedDt = responseData.resolved_dt || new Date().toISOString();

    // 🔹 Update alerts list
    let updatedAlerts = [...apiFilteredAlerts];
    if (resolveStatus === "Unresolved") {
      // Remove resolved alert from list
      updatedAlerts = updatedAlerts.filter(alert => alert.id !== alertId);
    } else {
      // Update alert with new threat and resolved_dt
      updatedAlerts = updatedAlerts.map(alert =>
        alert.id === alertId
          ? { ...alert, threats: updatedThreat, resolved_dt: resolvedDt }
          : alert
      );
    }

    // 🔹 Determine next selected alert
    let nextAlert = null;
    if (resolveStatus === "Unresolved") {
      nextAlert = updatedAlerts.find(alert => {
        const t = String(alert.threats).toLowerCase();
        return t !== "true" && t !== "truenonthreat" && t !== "false";
      });
    } else {
      nextAlert = updatedAlerts.find(alert => alert.id === alertId);
    }

    // 🔹 Update state with new resolved_dt and threat value
    this.setState({
      apiFilteredAlerts: updatedAlerts,
      selectedAlert: nextAlert
        ? { ...nextAlert, resolved_dt: resolvedDt } // ✅ force resolved_dt update
        : null,
      selectedAlertId: nextAlert?.id || null,
      selectedVideoUrl: nextAlert?.presigned_url || null,
      selectedRating: nextAlert
        ? (String(nextAlert.threats).toLowerCase() === "true" ? "trueThreat"
          : String(nextAlert.threats).toLowerCase() === "truenonthreat" ? "trueNonThreat"
          : String(nextAlert.threats).toLowerCase() === "false" ? "false"
          : "")
        : "",
    });

    this.openSnackbar("Threat status updated successfully.", "success");
  } catch (err) {
    console.error("❌ Error updating alert threat:", err);
    this.openSnackbar("Failed to update threat.", "error");
  }
};


//Update Notes Functionality 
updateAlertNote = async (noteText = "", useGet = false, alertIdOverride = null) => {
  const alertId = alertIdOverride || this.state.selectedAlert?.id;
  if (!alertId) {
    // alert("No alert selected.");
    this.openSnackbar("No alert selected.", 'warning');
    return;
  }

  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

  try {
    let url, options;

    if (useGet) {
      url = urls.GET_ALERT_NOTE(alertId);
      options = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    } else {
      url = urls.POST_UPDATE_ALERT_NOTE;
      options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: alertId,
          note: noteText,
        }),
      };
    }

    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`Failed to ${useGet ? "fetch" : "post"} note`);

    const data = await response.json();
    console.log("Fetched note data:", data);

    if (useGet) {
      const note = data?.note || "";
      // const history = data?.note_history || [];
      console.log("Fetched note:", note);
      this.setState({ noteText: note });
      return data;  // ✅ Return full data (note, site_name, camera_name, threats, etc.)
    } else {
      // alert("Note updated successfully.");
      this.openSnackbar("Note updated successfully.", 'success');
      this.setState({
        showNoteDialog: false,
        noteText: "",  // clear the input
     });
    }

    console.log(`✅ Note ${useGet ? "fetched" : "updated"} successfully`);
  } catch (error) {
    console.error(`❌ Error ${useGet ? "fetching" : "updating"} note:`, error);
    // alert(`Failed to ${useGet ? "fetch" : "update"} note`);
    this.openSnackbar(`Failed to ${useGet ? "fetch" : "update"} note`, 'error');
  }
};


// Filter byu Resolve status and Detection Type 
/* ----------  RESOLUTION  ----------------- */
handleResolveClick  = (e)     => this.setState({ anchorElResolve: e.currentTarget });
handleResolveClose  = ()      => this.setState({ anchorElResolve: null });
handleResolveSelect = (val) => {
  this.setState({ resolveStatus: val, anchorElResolve: null }, () => {
    this.apiFilteredAlerts(); // Automatically apply filter
  });
};


/* ----------  DETECTION  ------------------ */
handleDetectionClick  = (e)   => this.setState({ anchorElDetection: e.currentTarget });
handleDetectionClose  = ()    => this.setState({ anchorElDetection: null });
handleDetectionSelect = (val) => {
  let detectionType = this.state.detectionType;
  let selectedRating = this.state.selectedRatingOption;

  // 🎯 If user selects Detection
  if (['All', 'Bike', 'Car', 'Person'].includes(val)) {
    detectionType = val;
    selectedRating = null; // reset rating
  }

  // 🎯 If user selects Rating
  if (val === 'Threat') {
    selectedRating = 'trueThreat';
  } else if (val === 'Clear') {
    selectedRating = 'trueNonThreat';
  } else if (val === 'False') {
    selectedRating = 'false';
  }

  this.setState(
    {
      detectionType,
      selectedRatingOption:selectedRating,
      anchorElDetection: null,
      videoAlertPage: 1,
    },
    () => {
      this.apiFilteredAlerts();
    }
  );
};



// 🔴 Start Live Stream API call
startLiveStream = async (rtspUrl, cam_id) => {
  console.log("🚀 Starting live stream with RTSP URL:", rtspUrl, "and cam_id:", cam_id);
  try {
    const response = await fetch(urls.START_LIVE_STREAM(cam_id), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ rtspUrl }),
    });

    const text = await response.text();
    console.log("▶️ Start stream response:", response.status, text);

    if (!response.ok) throw new Error("Stream start failed");
    console.log("✅ Stream started");
    return true;
  } catch (err) {
    console.error("❌ Failed to start stream:", err);
    return false;
  }
};

// 🔴 Stop Live Stream API call
// stopLiveStream = async () => {
//   let cam_id = this.state.selectedCamId;
//   let alertId = this.state.selectedAlertId;
//   try {
//     const response = await fetch(urls.STOP_LIVE_STREAM(alertId), {  // Now using stream alert id instead of camera_id for fixing the issue of starting other live stream without stopping/closing previous one.
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//     });

//     const text = await response.text(); // log raw response
//     console.log("🛑 Stop stream response:", response.status, text);

//     if (!response.ok) {
//       throw new Error("Stream stop failed");
//     }

//     console.log("✅ Stream stopped");
//     return true;
//   } catch (err) {
//     console.error("❌ Failed to stop stream:", err);
//     return false;
//   }
// };

stopLiveStream = async (streamIds) => {
  console.log("streamIds -----> ", streamIds);
  const viewerId = localStorage.getItem(globalVariables.USER_ID);
  try {
    const response = await fetch(urls.STOP_MULTIPLE_LIVE_STREAMS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        streamIds: streamIds,
        viewerId: viewerId
      }),
    });

    const data = await response.json();
    console.log("🛑 Stop streams response:", data);

    return true;
  } catch (err) {
    console.error("❌ Failed to stop streams:", err);
    return false;
  }
};

handleCameraClick = async (alertObj) => { //function to fetch the vidio and other details regarding alert video on click of camera name from the alert record.
  if (!alertObj?.camera_rtsp_url) {
          window.alert("Missing RTSP URL.");
    return;
  }

  console.log("🎯 Selected RTSP URL and cam_id:", alertObj.camera_rtsp_url, alertObj.camera_id, alertObj.id);

  // 1. Fetch the list of cameras for this device
        const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
        const response = await get(urls.GET_UNMUTED_CAMERAS_FROM_ARMED_DEVICE(alertObj.device_id), headers);
        console.log("Fetched cameras for device:", response.cameras);
        if (response && response.cameras) {
          const defaultCamera = response.cameras.find(
            cam => cam.camera_id === alertObj.camera_id
          );
            this.setState({
                fetchedCamerasList: response.cameras || [],
                // Initialize with the alert's specific camera
                selectedLiveCameras: [{
                    camera_id: alertObj.camera_id,
                    camera_name: alertObj.camera_name,
                    rtsp_url: alertObj.rtsp_url, // Ensure this field exists in your alert object
                    selectedAlertId: alertObj.id,
                  }],
                // selectedLiveCameras: defaultCamera ? [{
                //   ...defaultCamera,
                //   selectedAlertId: alertObj.id
                // }] : [],
                
                selectedCamId: alertObj.camera_id,
                selectedAlertId: alertObj.id,
                // selectedAlert: alertObj,
            });
            
        }
        // Start the initial stream
  const success = await this.startLiveStream(alertObj.camera_rtsp_url, alertObj.id);  // Now using stream alert id instead of camera_id for fixing the issue of starting other live stream without stopping/closing previous one.

  if (success) {
    this.setState((prevState)=>({
      selectedAlert: alertObj,
      selectedRating: alertObj?.threats ?? null, // null if no rating
      // selectedAlertId: alertObj.id,
      // selectedCamId: alertObj.camera_id,
      showLiveStream: true,
      liveStreamBoxTop: prevState.liveStreamBoxTop || '13%',  // ✅ default to upper part of screen
      liveStreamBoxLeft: prevState.liveStreamBoxLeft || '55%', // ✅ center horizontally
    }));
  } 
  // else {
  //   window.alert("Live stream could not be started because it is already opened by some other user.");
  //   }
};

// handleLiveCameraSelection = async (event) => {
//   const { value } = event.target;
//   if (value.length > 6) return;
//   //---------------to stop the live stream of deselected camera----------------
//   const removedCameras = this.state.selectedLiveCameras.filter(
//     cam => !value.includes(cam.camera_id)
//   );

//   const removedStreamIds = removedCameras.map(
//     cam => String(cam.selectedAlertId)
//   );

//   console.log("Cameras to stop streaming:", removedStreamIds);

//   if (removedStreamIds.length > 0) {
//     await this.stopLiveStream(removedStreamIds);
//   }
//   //----------------------------------------------------------------------------
  
//   const updatedSelection = [];

//   for (const camId of value) {
//     const existingCam = this.state.selectedLiveCameras.find(
//       c => c.camera_id === camId
//     );

//     // If already selected, keep it
//     if (existingCam) {
//       updatedSelection.push(existingCam);
//       continue;
//     }

//     // New Camera Selected
//     const cam = this.state.fetchedCamerasList.find(
//       c => c.camera_id === camId
//     );

//     if (cam) {
//       // Start stream using camera_id as alertId
//       console.log("Starting stream for newly selected camera:", cam.camera_name, cam.camera_id);
//       const success = await this.startLiveStream(
//         cam.rtsp_url,
//         cam.camera_id   // ← camera_id used as alertId
//       );

//       if (success) {
//         updatedSelection.push({
//           ...cam,
//           selectedAlertId: cam.camera_id   // ← camera_id stored as alertId
//         });
//       }
//     }
//   }

//   this.setState({
//     selectedLiveCameras: updatedSelection
//   });
// };

handleLiveCameraSelection = async (event) => {

  // ✅ Remove duplicates
  const value = [...new Set(event.target.value.map(String))];
  // ✅ Max limit check
  if (value.length > 6) {
    // window.alert("Maximum 6 cameras can be viewed at once.");
    this.openSnackbar("Maximum 6 cameras can be viewed at once.","error");
    return;
  }

  const prevSelected = this.state.selectedLiveCameras.map(
    cam => String(cam.camera_id)
  );

  // Cameras removed
  const removedCameras = prevSelected.filter(
    id => !value.includes(id)
  );

  if (removedCameras.length > 0) {
    const removedStreamIds = this.state.selectedLiveCameras
      .filter(cam => removedCameras.includes(String(cam.camera_id)))
      .map(cam => String(cam.selectedAlertId));

    await this.stopLiveStream(removedStreamIds);
  }

  const updatedSelection = [];

  for (const camId of value) {

    const existingCam = this.state.selectedLiveCameras.find(
      c => String(c.camera_id) === camId
    );

    if (existingCam) {
      updatedSelection.push(existingCam);
      continue;
    }

    const cam = this.state.fetchedCamerasList.find(
      c => String(c.camera_id) === camId
    );

    if (cam) {
      const success = await this.startLiveStream(
        cam.rtsp_url,
        cam.camera_id
      );

      if (success) {
        updatedSelection.push({
          ...cam,
          selectedAlertId: cam.camera_id
        });
      }
    }
  }

  // this.setState({
  //   selectedLiveCameras: updatedSelection
  // });
  this.setState((prevState) => {
    // SELECTIVE RESET: Copy current failures, remove the IDs of any cameras that were unselected
    const updatedFailedStreams = { ...prevState.failedStreams };
    removedCameras.forEach((camId) => {
      delete updatedFailedStreams[camId];
    });

    return {
      selectedLiveCameras: updatedSelection,
      failedStreams: updatedFailedStreams
    };
  });
};

fetchNoteHistory = async (alertId) => { //function to get the notes history of selected camera alert. (rating of the alert, by whom, timestamp and snooze history too)
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const url = urls.VIDEO_ANALYTICS_HISTORY(alertId); // ✅ use new API

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });
    // console.log("fetchNoteHistory", response);

    if (!response.ok) throw new Error("Failed to fetch video analytics history");

    const history = await response.json();
    console.log("note history---", history);
    return history;
  } catch (err) {
    console.error("❌ Error fetching video analytics history:", err);
    return [];
  }
};

  openSnackbar = (msg, alert_type = 'warning' || 'success' || 'error' || 'info') => { //function to show the alerts
    console.log("Opening snackbar", new Date().toISOString());
    this.setState({
      open_snackbar: true,
      snackbar_msg: msg,
      alert_type: alert_type,
    })
  }

  lastAlertTImestampConversion = (time) =>{ // Not used anymore
    const date = new Date(time);

    const formatted = date.toLocaleString('en-US', {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    });

    console.log(formatted);
    return formatted

  }

    handleSnoozeCamera = async () => {    //function to snooze the selected camera
      const alertObj = this.state.selectedAlert;
      // const snoozeMinutes = 5;
      const snoozeMinutes = this.state.selectedSnoozeMinutes;
      if(snoozeMinutes === 0){
        console.log("Snoozing time is 0---");
        return;
      }
      if (!alertObj?.camera_id) {
        alert("Missing Camera ID");
        return;
      }

      const cameraId = alertObj.camera_id;

      console.log("Snoozing camera", cameraId);

      // STEP 1 → MUTE NOW
      await this.handleMuteUnmuteCameraNotifications(cameraId, "True");

      //-------------------------for multiple camera snooze and storing the snooze timer of individual camera in local storage so that even after page refresh or page load, we can get and see previous timers of cameras -------------
        // 2. Compute end time
        const endTime = Date.now() + snoozeMinutes * 60 * 1000;

        // 3. Load existing snoozed items
        const existing = JSON.parse(localStorage.getItem("snoozedCameras") || "{}");

        // 4. Add new camera snooze
        existing[cameraId] = endTime;

        // 5. Save
        localStorage.setItem("snoozedCameras", JSON.stringify(existing));
      //---------------------------------------------

      // STEP 2 → SET TIMER UI
      await this.startSnoozeCountdown(cameraId, snoozeMinutes);
      // await this.saveSnoozedByUser(cameraId, true);
    };

    startSnoozeCountdownFromEndTime = async (cameraId, endTime) => {

      const intervalId = setInterval(async () => {
        const now = Date.now();
        const remaining = Math.floor((endTime - now) / 1000);

        if (remaining > 0) {

          this.setState(prev => ({
            snoozeTimers: {
              ...prev.snoozeTimers,
              [cameraId]: this.formatTime(remaining)
            }
          }));

        } else {
          clearInterval(intervalId);

          // Auto-unmute
          await this.handleMuteUnmuteCameraNotifications(cameraId, "False");
          // if (camera.snooze === true && camera.mute === false) {
          // await this.saveSnoozedByUser(cameraId, false);
          // }

          // this.saveSnoozedByUser(cameraId, false);

          // Remove from storage
          const items = JSON.parse(localStorage.getItem("snoozedCameras") || "{}");
          delete items[cameraId];
          localStorage.setItem("snoozedCameras", JSON.stringify(items));

          // Remove timer UI
          this.setState(prev => {
            const updated = { ...prev.snoozeTimers };
            delete updated[cameraId];
            return { snoozeTimers: updated };
          });
        }

      }, 1000);
    };


    startSnoozeCountdown = async(cameraId, minutes) => {
      const endTime = Date.now() + minutes * 60 * 1000;

      // Save to localStorage
      const items = JSON.parse(localStorage.getItem("snoozedCameras") || "{}");
      items[cameraId] = endTime;
      localStorage.setItem("snoozedCameras", JSON.stringify(items));

      // Start the real countdown using timestamp
      await this.startSnoozeCountdownFromEndTime(cameraId, endTime);
    };

    formatTime = (secs) => {
      const m = String(Math.floor(secs / 60)).padStart(2, "0");
      const s = String(secs % 60).padStart(2, "0");
      return `${m}:${s}`;
    };

    
    handleMuteUnmuteCameraNotifications = async (CameraId, muteStatus) => {
      console.log("selected cam id---handleMuteUnmuteCameraNotifications-----", CameraId, muteStatus);
      const{cameras } = this.state
      // console.log("selectedCameraId-----", selectedCameraId);
  
      let data = { // Now backend API is not accepting any body data for snooze mute/unmute camera, only camera id in URL is sufficient to perform the action.
        "mute": muteStatus,
      }
      let post_data = JSON.stringify(data)
      console.log("data---MuteUnmute----", post_data);
  
  
      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        // 
        let headers = {
          // 'content-type': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${access_tocken}`
        }
        // Call custom get method
       let  url = urls.SNOOZE_CAMERA(CameraId)
        console.log("url---MuteUnmute----", url);
  
        let response1 = await post(urls.SNOOZE_CAMERA(CameraId), post_data, headers)
        console.log('res-------->', response1);
        
        // if (response1) {
        // const updatedCameras = cameras.map(camera => {
        //   if (camera.id === CameraId) {
        //     return { ...camera, mute }; // update mute status in the array
        //   }
        //   return camera;
        // });
  
        // this.setState({
        //   muteResponseMessage: response1.message,
        //   success2: true,
        //   cameras: updatedCameras,
        // });
        // ✅ Delay for 1.5 seconds before calling cameraSync
        // await new Promise(resolve => setTimeout(resolve, 1000));
        // // this.cameraSync()
        // this.LoadSelectedDeviceInfo(this.state.Selected_Device_Id);
  
      // }
      if (muteStatus === "True") {
        this.saveSnoozedByUser(CameraId, true);
      }
      else{
        this.saveSnoozedByUser(CameraId, false);
      }
    }
      catch (error) {
        console.error('Error:', error);
      }
  
    }

    restoreAllSnoozeTimers = async () => {
      const items = JSON.parse(localStorage.getItem("snoozedCameras") || "{}");

      Object.keys(items).forEach(async cameraId => {
        const endTime = items[cameraId];
        const now = Date.now();

        if (now < endTime) {
          // Restore timer
          await this.startSnoozeCountdownFromEndTime(cameraId, endTime);
        } else {
          // Snooze expired while page was closed → auto-unmute
          await this.handleMuteUnmuteCameraNotifications(cameraId, "False");
          // await this.saveSnoozedByUser(cameraId, false);

          // Cleanup expired camera
          delete items[cameraId];
          localStorage.setItem("snoozedCameras", JSON.stringify(items));
        }
      });
    };

    // restoreAllSnoozeTimers = () => {
    //   const stored = JSON.parse(localStorage.getItem("snoozedCameras") || "{}");

    //   Object.entries(stored).forEach(([cameraId, endTime]) => {
    //     const remaining = Math.floor((endTime - Date.now()) / 1000);
    //     if (remaining > 0) {
    //       // ❗ Clear any existing timer before restoring
    //       if (this.snoozeIntervals[cameraId]) {
    //         clearInterval(this.snoozeIntervals[cameraId]);
    //         delete this.snoozeIntervals[cameraId];
    //       }

    //       this.startSnoozeCountdown(cameraId, remaining / 60);
    //     } else {
    //       delete stored[cameraId];
    //       localStorage.removeItem(`snoozeStopped_${cameraId}`);
    //     }
    //   });

    //   localStorage.setItem("snoozedCameras", JSON.stringify(stored));
    // };

    // added below two functions to handle next and previous page navigation instead on writing logic in jsx'x onClick directly
    handleNextPage = () => {
      const nextPage = this.state.videoAlertPage + 1;

      // STOP AUTO-REFRESH WHEN MOVING NEXT PAGE TO 1
      if (this.state.autoRefreshEnabled) {
        this.setState({ autoRefreshEnabled: false });
        if (this.state.pollingIntervalId) clearInterval(this.state.pollingIntervalId);
      }

      this.apiFilteredAlerts(nextPage);
    };

    handlePrevPage = () => {
      const prevPage = this.state.videoAlertPage - 1;

      if (prevPage === 1 && this.isFilterInactive()) {
        if (this.state.pollingIntervalId) {
          clearInterval(this.state.pollingIntervalId);
        }
        // RE-ENABLE AUTO REFRESH
      //   this.setState({ autoRefreshEnabled: true }, () => {
      //     this.startAutoRefreshPolling();
      //   });
      // }

      // this.apiFilteredAlerts(prevPage);

        this.setState(
        { pollingIntervalId: null, videoAlertPage: 1, autoRefreshEnabled: true },
        () => {
          this.startAutoRefreshPolling();
          this.apiFilteredAlerts(1); // immediate fetch
        }
        );
        return; //TODO VERIFY is caused any problem, remove it.
      }
      this.apiFilteredAlerts(prevPage);
    };

    saveSnoozedByUser = async (cameraId, isSnoozed) => {  //function to save the user_name who snoozed the camera.
      let USER_NAME = localStorage.getItem(globalVariables.USER_NAME);
      let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);

      console.log("selected cam id---saveSnoozedByUser-----", cameraId, isSnoozed, USER_NAME, authToken);
      let data = {
        "camera": cameraId,
        "snooze": isSnoozed,
        "snooze_user": USER_NAME,
      }
      let post_data = JSON.stringify(data)
      console.log("data---saveSnoozedByUser----", post_data);
      try {
        let headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${authToken}`
        }
        const response = await post(urls.CAMERA_SNOOZE_BY_USER, post_data, headers);
        console.log('res---saveSnoozedByUser----->', response);
        if (response.message === "Successfully added") {
          this.setState({
            // snoozeByUserResponseMessage: response.message,
            Snoozed_by : response.data.snooze_user,
            Snooze_time : response.data.timestamp,
            // success3: true,
          });
        }
      }
      catch (error) {
        console.error('Error:', error);
      }
    }

    connect = () => {
      let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);

      // this.ws = new WebSocket(
      //   `${process.env.REACT_APP_WS_URL}/ws/nvr/tenant/${tenantId}/device/${deviceName}/`
      // );
      // this.ws = new WebSocket(`wss://api.eyeon8i.com/ws/device-status/?token=${authToken}`);  // prod server
      this.ws = new WebSocket(`wss://devapi.neudeep.com/ws/device-status/?token=${authToken}`); //dev server.
      // this.ws = new WebSocket("ws://localhost:8000/ws/nvr/tenant/tenantA/device/device123/");
      this.ws.onopen = () => {
        console.log("✅ Connected to NVR WS");
      };

      this.ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        console.log("websocket message for pop-up notification", msg);

        if(msg?.type === "camera_status" && msg?.status !== "online") {
           console.log("Calling addNotification", new Date().toISOString());
          // this.openSnackbar(`Camera ${msg?.camera_name} of device ${msg?.device_name} is ${msg?.status}.`, "error");
          this.addNotification(
            `Camera ${msg.camera_name} of device ${msg.device_name} is ${msg.status}`
          );
        }

        // Example filter – adapt to your payload
        if (msg.device_id) {
          // alert("New Message Received: " + JSON.stringify(msg.device_camera_id + " is " + msg.payload.status));
          
        this.updateWsAlerts(msg);
        }
        // 🔁 update state / redux here if needed
        // this.setState(...)
      };

      this.ws.onclose = () => {
        console.log(" Reconnecting in 3s...");
        this.reconnectTimer = setTimeout(this.connect, 3000);
      };

      this.ws.onerror = (event) => {
        // this.ws.close();
        console.log("WS error:", event);
        const socket = event.target;
        if (socket && socket.readyState !== WebSocket.CLOSED) {
          socket.close();
        }
      };
    };
// Use the below commented function along with showCombinedNotification() if you want to show the combined notification of multiple alerts in a single pop-up instead of showing one after the other.
// addNotification = (message) => {
//   const now = Date.now();

//   Object.keys(this.recentAlerts).forEach((key) => {
//     if (now - this.recentAlerts[key] > 30000) {
//       delete this.recentAlerts[key];
//     }
//   });

//   if (
//     this.recentAlerts[message] &&
//     now - this.recentAlerts[message] < 30000
//   ) {
//     return;
//   }

//   this.recentAlerts[message] = now;

//   this.setState(
//     (prevState) => ({
//       pendingNotifications: [
//         ...prevState.pendingNotifications,
//         message,
//       ],
//     }),
//     () => {
//       if (!this.notificationTimer) {
//         this.notificationTimer = setTimeout(() => {
//           this.showCombinedNotification();
//         }, 1000);
//       }
//     }
//   );
// };

// showCombinedNotification = () => {
//   const { pendingNotifications } = this.state;

//   if (!pendingNotifications.length) return;

//   const combinedMessage =
//     pendingNotifications.length === 1
//       ? pendingNotifications[0]
//       : pendingNotifications.join("\n");

//   this.openSnackbar(combinedMessage, "error");

//   this.setState({
//     pendingNotifications: [],
//   });

//   this.notificationTimer = null;
// };

// Function to show one notification at a time, with a 1-minute delay between them (using a queue system)

  addNotification = (message) => {
    const now = Date.now();

    // Remove expired entries
    Object.keys(this.recentAlerts).forEach((key) => {
      if (now - this.recentAlerts[key] > 30000) {
        delete this.recentAlerts[key];
      }
    });

    // Ignore duplicates for 30 seconds
    if (
      this.recentAlerts[message] &&
      now - this.recentAlerts[message] < 30000
    ) {
      return;
    }

    this.recentAlerts[message] = now;

    this.setState(
      (prevState) => ({
        notificationQueue: [
          ...prevState.notificationQueue,
          message,
        ],
      }),
      () => {
        this.processNotificationQueue();
      }
    );
  };

  processNotificationQueue = () => {
    if (this.isShowingNotification) return;

    const { notificationQueue } = this.state;

    if (!notificationQueue.length) return;

    const nextMessage = notificationQueue[0];

    this.isShowingNotification = true;

    this.openSnackbar(nextMessage, "error");

    this.setState(
      (prevState) => ({
        notificationQueue: prevState.notificationQueue.slice(1),
      }),
      () => {
        // Start 1 minute cooldown immediately
        this.notificationCooldown = setTimeout(() => {
          this.isShowingNotification = false;
          this.notificationCooldown = null;

          this.processNotificationQueue();
        }, 30000);
      }
    );
  };

  handleSnackbarClose = () => {
    this.setState({
      open_snackbar: false,
    });

    // // Wait 1 minute before showing next queued alert
    // setTimeout(() => {
    //   this.isShowingNotification = false;
    //   this.processNotificationQueue();
    // }, 60000);
  };


    updateWsAlerts = async (alert) => {
      const isDeviceAlert =
        alert.status === "inactive" || alert.status === "offline";

      const isCameraAlert =
        alert.type === "camera_status" &&
        ["unstable"].includes(alert.status);

      const isCameraRecovery =
        alert.type === "camera_status" && alert.status === "online";

      const isAlert = (isDeviceAlert || isCameraAlert) && !isCameraRecovery;

      // Unique identity:
      // device alert → device_id
      // camera alert → camera_id
      const alertKey =
        alert.type === "camera_status"
          ? `camera-${alert.camera_id}`
          : `device-${alert.device_id}`;

      let dbAction = null;
      let dbPayload = null;

      this.setState((prevState) => { 
        const existingIndex = prevState.wsAlerts.findIndex(
          (a) => a._key === alertKey
        );

        /* -----------------------------
          CASE 1: ALERT STATE
        ------------------------------*/
        if (isAlert) {
          // Already exists → ignore duplicate
          // if (existingIndex !== -1) {
          //   return null;
          // }
          const user_Id = localStorage.getItem(globalVariables.USER_ID);
          let duration = "5.00"
          const newAlert = {
            id: `${alertKey}-${Date.now()}`,
            _key: alertKey,
            userId: user_Id,                 // internal use only
            type: alert.type || "device",

            // Device info
            nvrId: alert.device_id || "-",
            deviceName: alert.device_name || "-",

            // Camera info (optional)
            cameraId: alert.camera_id || "-",
            cameraName: alert.camera_name || "-",

            status: alert.status || "-",
            receivedAt: alert.updated_at || alert.timestamp || new Date().toISOString(),
            error: alert.error_message || "-",
            offline_duration: alert.duration || "-", //TODO variable name mismatch websocket and api record
          };

          // const updatedAlerts = [newAlert, ...prevState.wsAlerts];

          // return {
          //   wsAlerts: updatedAlerts,
          //   totalWsAlertCount: updatedAlerts.length,
          // };
          // If already exists → replace it
          let updatedAlerts;
          if (existingIndex !== -1) {
              const filtered = prevState.wsAlerts.filter(
              (a) => a._key !== alertKey
            );

            updatedAlerts = [newAlert, ...filtered];
          } else {
            updatedAlerts = [newAlert, ...prevState.wsAlerts];
          }

          return {
            wsAlerts: updatedAlerts,
            totalWsAlertCount: updatedAlerts.length,
          };
        }

        /* -----------------------------
          CASE 2: RECOVERY (ACTIVE)
          → remove old alert silently
        ------------------------------*/
        // if (existingIndex !== -1) {

        //   // Promise.resolve().then(async () => {
        //   //   await alertsDB.alerts.delete(alertKey);
        //   //   console.log("----- Alert removed from IndexedDB:", alertKey);
        //   // });

        //   const updatedAlerts = prevState.wsAlerts.filter(
        //     (a) => a._key !== alertKey
        //   );

        //   return {
        //     wsAlerts: updatedAlerts,
        //     totalWsAlertCount: updatedAlerts.length,
        //   };
        // }

        return null;
      });
      
    };

    cleanup = () => {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    };

  closePopup = () => {
    this.setState({ showWsAlertTable: false });
  };

  getAlertUIConfig = (count) => {
  if (count === 0) {
    return {
      icon: sirenStrobeIconGreen,   // ✅ green icon
      badgeColor: "success",
      animationClass: "",
      tooltip: "No active alerts",
      clickable: false,
    };
  }

  return {
    icon: sirenStrobeIconRed,       // ✅ red icon
    badgeColor: "error",
    animationClass: "strobe",
    tooltip: "Active alerts",
    clickable: true,
  };
  };

  getInactiveDeviceNotificationList = async () => {
    try{
      // this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          // 
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }
          const response = await get(urls.INACTIVE_DEVICES_NOTIFICATION, headers); //  API call to get the rtsp camera's sites(devices) list w.r.t selected group
          // this.stopLoading();
          let inactiveList = response;
          console.log("API Response:---getInactiveDeviceNotificationList---------------------------------------->>>", response);
          // let dbAction = null;
          // let dbPayload = null;
          const apiAlerts = inactiveList.map(item => ({
            id: `device-${item.id}-api`,        // unique row id, kept it same as in websocket alerts mapping
            _key: `device-${item.id}`,          // CRITICAL
            type: "device",

            // Device info (match WS fields)
            nvrId: item.id,
            deviceName: item.device_name,

            // Camera fields (not applicable)
            cameraId: item.camera_id || "-",
            cameraName: item.camera_name || "-",

            status: item.status || "-",
            receivedAt: item.updated_at,
            error: item.error_message || "-",
            offline_duration: "-",
            source: "api",                      // optional (debug only)
          }));

          this.mergeWsAlerts(apiAlerts);

          // dbAction = "add";
          // const dbPayload = apiAlerts.map(alert => ({
          //   ...alert,
          //   userId: this.state.userId, // VERY IMPORTANT
          // }));

          // this.setState({
          //   wsAlerts: apiAlerts,
          //   totalWsAlertCount: apiAlerts.length,
          // });

      //     if (dbAction === "add") {
      //   await alertsDB.alerts.bulkPut(dbPayload);
      //   console.log("------ Alert stored in IndexedDB:------", {
      //       userId: this.state.userId,
      //       count: dbPayload.length
      //     });
      // }
          
    } catch {
      console.error("Error fetching notification alert list");
      return [];
    }
  }

  fetchOfflineCameras = async () => {
    try{
      // this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          // 
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
          }
          const response = await get(urls.OFFLINE_CAMERA_NOTIFICATION, headers); //  API call to get the rtsp camera's sites(devices) list w.r.t selected group
          // this.stopLoading();
          let OfflineList = response.cameras;
          console.log("API Response:---fetchOfflineCameras---------------------------------------->>>", response);
          
          const apiAlerts = OfflineList.map(item => ({
            id: `camera-${item.camera_id}-api`,        // unique row id, kept it same as in websocket alerts mapping
            _key: `camera-${item.camera_id}`,          // CRITICAL
            type: "camera_status",

            // Device info (match WS fields)
            nvrId: item.id,
            deviceName: item.device_name,

            // Camera fields (not applicable)
            cameraId: item.camera_id || "-",
            cameraName: item.camera_name || "-",

            status: item.status,
            receivedAt: item.timestamp,
            error: "-",
            offline_duration: item.offline_duration,
            source: "api",                      // optional (debug only)
          }));
          this.mergeWsAlerts(apiAlerts);

      //     dbAction = "add";
      //     const dbPayload = apiAlerts.map(alert => ({
      //       ...alert,
      //       userId: this.state.userId, // VERY IMPORTANT
      //     }));

      //     this.setState({
      //       wsAlerts: apiAlerts,
      //       totalWsAlertCount: apiAlerts.length,
      //     });

      //     if (dbAction === "add") {
      //   await alertsDB.alerts.bulkPut(dbPayload);
      //   console.log("------ Alert stored in IndexedDB:------", {
      //       userId: this.state.userId,
      //       count: dbPayload.length
      //     });
      // }
          
    } catch {
      console.error("Error fetching notification alert list");
      return [];
    }
  };

  mergeWsAlerts = (newAlerts) => {
    this.setState(prevState => {
      const map = {};

      // existing alerts
      prevState.wsAlerts.forEach(a => {
        map[a._key] = a;
      });

      // new alerts (API)
      newAlerts.forEach(a => {
        map[a._key] = a; // overwrite-safe
      });

      const merged = Object.values(map);

      return {
        wsAlerts: merged,
        totalWsAlertCount: merged.length,
      };
    });
  };

  updateTime = () => {
  const { tempHour, tempMinute, tempPeriod, isStart } = this.state;

  if (!tempHour || !tempMinute || !tempPeriod) return;

  const formatted = `${String(tempHour).padStart(2,"0")}:${String(tempMinute).padStart(2,"0")} ${tempPeriod}`;

  if (isStart) {
    this.setState({
      startTime: formatted,
      anchorEl: null,
    });
  } else {
    this.setState({
      endTime: formatted,
      anchorEl: null,
    });
  }
};

  convertToMinutes = (timeStr) => {
    if (!timeStr) return null;

    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };

  getVariant = (value) => {
    const { selectedRating } = this.state;
    const validRatings = ["trueThreat", "trueNonThreat", "false"];

    // If not rated yet → all contained
    if (!validRatings.includes(selectedRating)) return "contained";

    // If rated → only selected one contained
    return selectedRating === value ? "contained" : "outlined";
  };

  isUnrated = () => {
    const validRatings = ["trueThreat", "trueNonThreat", "false"];
    return !validRatings.includes(this.state.selectedRating);
  };

  isActive = (value) => {
    return this.state.selectedRating === value || this.isUnrated();
  };

  handlePowerToggle = async (pagingDevice) => {
  const { audioEnabled } = this.state;
  const mac = pagingDevice?.mac_address;

  if (!mac){
    this.openSnackbar("Mac address or paging is not available for this Site.","error");
    return} ;

  if (audioEnabled) {
    // Turning OFF → stop everything
    if (this.audioRef.current) {
      this.audioRef.current.pause();
      this.audioRef.current.currentTime = 0;
    }

     try {
        let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${authToken}`
        }
        let url = `https://devapi.neudeep.com/api/alerts/speaker/${mac}/stop/`;
        // let url = `https://api.eyeon8i.com/api/alerts/speaker/${mac}/stop/`;
        console.log("url---handlePowerToggle speaker off----", url);
        const response = await post(url, headers);
        console.log('res---handlePowerToggle speaker off----->', response);
        
        if (response.success === true) {
         this.setState({
            audioEnabled: false,
            selectedAudio: "6",
            isAudioPlaying: false,
          });
        }
      }
      catch (error) {
        console.error('Error:', error);
      }
    
    
  } else {
     try {
        let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${authToken}`
        }
        let url = `https://devapi.neudeep.com/api/alerts/speaker/${mac}/listen/`;
        // let url = `https://api.eyeon8i.com/api/alerts/speaker/${mac}/listen/`;
        console.log("url---handlePowerToggle speaker on----", url);
        const response = await post(url, headers);
        console.log('res---handlePowerToggle----->', response);
        
        if (response.success === true) {
        this.setState({ audioEnabled: true });
        this.handleAudioPlayPause(); // Auto-play when turned on
        }
        else{
          this.openSnackbar("Failed to listen to the mac address, ", "error");
        }
      }
      catch (error) {
        console.error('Error:', error);
      }
    
  }
};

  handleAudioPlayPause = async () => {
    const { isAudioPlaying, selectedAudio } = this.state;

    if (!selectedAudio) return;

    if (!isAudioPlaying) {
      // Later replace with API call
      // await this.apiPlayAudio(selectedAudio);

      // this.audioRef.current.play();
       try {
        let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${authToken}`
        }
        let url = `https://devapi.neudeep.com/api/alerts/speaker/play/6/`;
        // let url = `https://api.eyeon8i.com/api/alerts/speaker/play/6/`;
        console.log("url---handleAudio Play file ----", url);
        const response = await post(url, headers);
        console.log('res---handleAudioPlayPause----->', response);
        
        if (response.success === true) {
        this.setState({ isAudioPlaying: true });
        }
      }
      catch (error) {
        console.error('Error:', error);
      }
      
    } else {
      this.audioRef.current.pause();
      try {
        let authToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${authToken}`
        }
        let url = `https://devapi.neudeep.com/api/alerts/speaker/play/stop/message-msg_files-6-2/`;
        // let url = `https://api.eyeon8i.com/api/alerts/speaker/play/stop/message-msg_files-6-2/`;
        console.log("url---handleAudio file Pause----", url);
        const response = await post(url, headers);
        console.log('res---handleAudioPlayPause----->', response);
        if (response.success === true) {
          this.setState({ isAudioPlaying: false });
        }
        
      }
      catch (error) {
        console.error('Error:', error);
      }
      
    }
};

getGridColumns = () => {
  const count = this.state.selectedLiveCameras.length;

  if (count === 1) return "1fr";
  if (count === 2) return "repeat(2, 1fr)";
  return "repeat(3, 1fr)";
};

handleFocusCamera = (cam) => {
  this.setState({ focusedCamera: cam });
};

handleExitFocus = () => {
  this.setState({ focusedCamera: null });
};

handleEsc = (e) => {
  if (e.key === "Escape") {
    this.setState({ focusedCamera: null });
    this.handleCloseLiveStream();
  }
};

handleIconClick = async () => {
  try {
    
    await Promise.all([
      this.getInactiveDeviceNotificationList(),
      this.fetchOfflineCameras(),
    ]);
    this.setState({ showWsAlertTable: true });
  } catch (error) {
    console.error(error);
  }
};

  handleStreamError = (cameraId) => {
      this.setState((prevState) => ({
          failedStreams: {
              ...prevState.failedStreams,
              [cameraId]: true
          }
      }));
  };

    render() {


        const { groups_list, startDate, endDate, startTime, endTime, dateError, todayDate, selectedCamId, selectedAlertId } = this.state;
        //console.log("🧪 alertsToShow:", alertsToShow);
        const alertsToShow = this.state.apiFilteredAlerts.length > 0 ? this.state.apiFilteredAlerts : this.state.filteredAlerts;
        console.log("🟨 Alerts To Show:", alertsToShow.length, alertsToShow);

        // const isApiMode = this.state.apiFilteredAlerts.length > 0;
        // let user_name = localStorage.getItem(globalVariables.USER_NAME);
        // let storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
        let speaker_permission = localStorage.getItem(globalVariables.SPEAKER_PERMISSION);

        const disableAutoToggle = !this.isFilterInactive();
        const autoRefreshMessage = disableAutoToggle
            ? "Auto-refresh is disabled when filters or dates are selected"
            : (this.state.autoRefreshEnabled
            ? "Click to disable auto-refresh"
            : "Click to enable auto-refresh");
        
            const { videoAlertPage, pageSize, totalAlertCount } = this.state;
            const start = totalAlertCount === 0
            ? 0
            :(videoAlertPage - 1) * pageSize + 1;
                      let end = videoAlertPage * pageSize;
                      if (end > totalAlertCount) end = totalAlertCount;

        const history = this.state.noteHistory || [];
        const normalHistory = history.slice(0, -1); // all except last
        const snoozeEntry = history[history.length - 1]; // last item

        const count = this.state.totalWsAlertCount;
        const ui = this.getAlertUIConfig(count); 
        const isSameDate = startDate && endDate && startDate === endDate;

        const objectIconMap = {
          person: DirectionsWalkRounded,
          car: DirectionsCarFilledRounded,
          bike: TwoWheelerRounded,
          motorbike: TwoWheelerRounded,
        };

        const viewerId = localStorage.getItem(globalVariables.USER_ID);

        return (
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <div className="alert-tab-page" style={{ height: "100vh" }}>
              {/* Global connectivity monitor */}
              <InternetConnectionDetector />
                
              <Navigationbar />
              <div className="alert-tab-scroll-container">
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: { xs: 1, sm: 2 }, ml: { xs: 0, md: 12 }, height: { xs: 'auto', md: '95vh' }, minWidth: 0 }}>
                  {/* Filters Section */}
                  <Box component={Paper} sx={{ display: "flex", flexWrap: { xs: 'wrap', md: 'nowrap' }, alignItems: 'flex-start', gap: 1, width: "100%", mt: 1, p: { xs: 1, md: 0 }, minWidth: 0 }}>
                  
                    <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 170 }, flex: { xs: '1 1 100%', sm: '1 1 170px', md: '0 0 170px' } }}>
                        <InputLabel>Sites</InputLabel>
                      <Select
                          value={this.state.selected_sites.length > 0 ? this.state.selected_sites[0] : ''}
                          onChange={(e) => {
                              const selected = e.target.value;
                                    this.setState({
                                    selected_sites: [selected],
                                    selected_devices: [],
                                    selected_cameras: [],
                                    devices: [],
                                    cameras: [],
                                    startTime: "",
                                    endTime: ""
                                  }, async () => {
                                    await this.fetchDevicesForSelectedSites();
                                    await this.fetchCamerasForSelectedDevices();
                                  });
                                }}
                                renderValue={(selected) => {
                                  const site = this.state.site_list.find(s => s.id === selected);
                                    return site?.sitename || selected;
                                  }}
                              >
                                {this.state.site_list.map((siteItem) => (
                          <MenuItem key={siteItem.id} value={siteItem.id}>
                          {siteItem.sitename}
                        </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* Device Selection */}
                    <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 170 }, flex: { xs: '1 1 100%', sm: '1 1 170px', md: '0 0 170px' } }}>
                        <InputLabel>Devices</InputLabel>
                        <Select
                            multiple
                            value={this.state.selected_devices}
                            onChange={(e) => {
                                const selected = typeof e.target.value === 'string'
                                    ? e.target.value.split(',')
                                    : e.target.value;

                                this.setState({ selected_devices: selected }, () => {
                                    this.fetchCamerasForSelectedDevices();
                                });
                            }}
                            renderValue={(selected) => (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 1,
                                        maxHeight: 200,
                                        overflowY: 'auto',
                                    }}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    {selected.map((deviceId) => {
                                        const device = this.state.devices.find(d => d.id === deviceId);
                                        return (
                                            <Chip
                                                key={deviceId}
                                                label={device?.device_name || deviceId}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    this.handleDeleteDevice(deviceId);
                                                }}
                                                sx={{ width: 'fit-content' }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}

                        >
                            {this.state.devices.map((deviceItem) => (
                                <MenuItem key={deviceItem.id} value={deviceItem.id}>
                                    {deviceItem.device_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    {/* Camera Selection */}
                    <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 170 }, flex: { xs: '1 1 100%', sm: '1 1 170px', md: '0 0 170px' } }}>
                        <InputLabel>Cameras</InputLabel>
                        <Select
                            multiple
                            name="cameraId"
                            value={this.state.selected_cameras}
                            onChange={(e) => this.setState({ selected_cameras: e.target.value })}

                            renderValue={(selected) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '4px',
                                        maxHeight: '200px',
                                        overflowY: 'auto'
                                    }}
                                    onMouseDown={(e) => e.stopPropagation()} // ✨ This is the key
                                >
                                    {selected.map((cameraId) => {
                                        const cam = this.state.cameras.find((c) => c.id === cameraId);
                                        return (
                                            <Chip
                                                key={cameraId}
                                                label={cam?.camera_name || cameraId}
                                                onDelete={(e) => {
                                                    e.stopPropagation(); // ✨ Prevent dropdown from closing
                                                    this.setState((prevState) => ({
                                                        selected_cameras: prevState.selected_cameras.filter(id => id !== cameraId),
                                                    }));
                                                }}
                                            />
                                        );
                                    })}
                                </div>
                            )}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 300,
                                    },
                                },
                                disableAutoFocusItem: true, // ✨ Prevent auto-focus side effects
                            }}
                        >
                            {this.state.cameras.map((cameraItem) => (
                                <MenuItem key={cameraItem.id} value={cameraItem.id}>
                                    {cameraItem.camera_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Date Selection */}
                    <TextField
                        label="Start Date"
                        type="date"
                        variant="outlined"
                        size="small"
                        name="startDate"
                        fontSize="12px"
                        color="#fff"
                        value={startDate}
                        onChange={this.handleDateChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{ min: "2022-01-01" }}  // Allow selection of previous months (or any desired start date)
                        sx={{
                              width: { xs: '100%', sm: 170 },
                              flex: { xs: '1 1 100%', sm: '1 1 170px', md: '0 0 170px' },
                              "& input[type='date']::-webkit-calendar-picker-indicator": {
                              filter: "invert(1)", // makes icon white
                              cursor: "pointer",
                            },
                          }}
                    />

                    <TextField
                        label="End Date"
                        type="date"
                        variant="outlined"
                        size="small"
                        name="endDate"
                        value={endDate}
                        onChange={this.handleDateChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{ min: startDate || todayDate }} // Ensure end date is >= start date or today
                        sx={{
                          width: { xs: '100%', sm: 170 },
                          flex: { xs: '1 1 100%', sm: '1 1 170px', md: '0 0 170px' },
                          "& input[type='date']::-webkit-calendar-picker-indicator": {
                              filter: "invert(1)", // makes icon white
                              cursor: "pointer",
                            },
                        }}
                    />
                    <Popover
                      open={Boolean(this.state.anchorEl)}
                      anchorEl={this.state.anchorEl}
                      onClose={() => this.setState({ anchorEl: null })}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left", 
                      }}
                    >
                      <Box sx={{ p: 1, display: "flex", gap: 1 }}>

                        {/* Hour */}
                        <Select
                          value={this.state.tempHour}
                          onChange={(e) =>
                            this.setState({ tempHour: e.target.value })
                          }
                          sx={{ width: 70, height:30, fontSize:12 }}
                        >
                          {Array.from({ length: 12 }, (_, i) => (
                            <MenuItem key={i} value={i + 1}>
                              {String(i + 1).padStart(2, "0")}
                            </MenuItem>
                          ))}
                        </Select>

                        :

                        {/* Minute */}
                        <Select
                          value={this.state.tempMinute}
                          onChange={(e) =>
                            this.setState({ tempMinute: e.target.value })
                          }
                          sx={{ width: 70, height:30 }}
                        >
                          {Array.from({ length: 60 }, (_, i) => (
                            <MenuItem key={i} value={i}>
                              {String(i).padStart(2, "0")}
                            </MenuItem>
                          ))}
                        </Select>

                        {/* AM/PM */}
                      <Select
                          value={this.state.tempPeriod}
                          displayEmpty
                          onChange={(e) => {
                            const period = e.target.value;
                            const { tempHour, tempMinute, isStart } = this.state;

                            // ✅ FIXED CONDITION
                            if (tempHour === "" || tempMinute === "") return;

                            const formatted = `${String(tempHour).padStart(2,"0")}:${String(tempMinute).padStart(2,"0")} ${period}`;
                            // Convert times to minutes for comparison
                            const selectedMinutes = this.convertToMinutes(formatted);
                            const startMinutes = this.convertToMinutes(startTime);

                            // Restrict invalid end time
                            if (!isStart && startMinutes !== null && selectedMinutes <= startMinutes) {
                              alert("End time must be greater than Start time");
                              return;
                            }

                            if (isStart) {
                              this.setState({
                                startTime: formatted,
                                tempPeriod: period,
                                anchorEl: null,
                              });
                            } else {
                              this.setState({
                                endTime: formatted,
                                tempPeriod: period,
                                anchorEl: null,
                              });
                            }
                          }}
                          sx={{ width: 60, height:25, fontSize:12 }}
                        >
                        <MenuItem disabled>Select</MenuItem>
                        <MenuItem value="AM">AM</MenuItem>
                        <MenuItem value="PM">PM</MenuItem>
                      </Select>

                      </Box>
                    </Popover>
                    {/*  Time Selection */}
                    <Tooltip 
                      title={!isSameDate ? "Start and end date should be the same to enable time filtering" : "Select start and end time for filtering"}
                      placement="bottom-start"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: '#283348',
                            color: '#fff',
                            fontSize: '12px',
                            border: '1px solid #99acb8',
                          },
                        },
                        arrow: {
                          sx: {
                            color: '#283348',
                          },
                        },
                      }}
                    >
              <Box sx={{ display: 'flex', gap: 1, flex: { xs: '1 1 100%', sm: '1 1 268px', md: '0 0 auto' }, minWidth: 0 }}>
              <TextField
                label="Start Time"
                size="small"
                value={this.state.startTime}
                disabled={!isSameDate}
                onClick={(e) => {
                  if (!isSameDate) return;

                  this.setState({
                    anchorEl: e.currentTarget,
                    isStart: true,
                    tempHour: "",
                    tempMinute: "",
                    tempPeriod: "",
                  });
                }}
                InputProps={{ readOnly: true }}
                sx={{ width: { xs: '50%', md: 130 }, minWidth: 0 }}
              />

              <TextField
                label="End Time"
                size="small"
                value={this.state.endTime}
                disabled={!isSameDate}
                onClick={(e) => {
                  if (!isSameDate) return;

                  this.setState({
                    anchorEl: e.currentTarget,
                    isStart: false, 
                    tempHour: "",
                    tempMinute: "",
                    tempPeriod: "",
                  });
                }}
                InputProps={{ readOnly: true }}
                sx={{ width: { xs: '50%', md: 130 }, minWidth: 0 }}
              />
              </Box>
                    </Tooltip>
                    {dateError && (
                        <FormHelperText error>{dateError}</FormHelperText>
                    )}
                    {/*<Button variant="contained" color="primary">Apply</Button>*/}
                    <Button
                      id="applyFilterButton"
                      sx={{ fontWeight: 'bold', height: 35, flex: { xs: '1 1 120px', sm: '0 0 auto' } }}
                      onClick={this.handleApplyFilters}
                    >
                      Apply
                    </Button>

                    <Button 
                      id="clearFilterLogButton" 
                      sx={{ fontSize: '12px', fontWeight: 'bold', height: 35, flex: { xs: '1 1 120px', sm: '0 0 auto' } }}
                      onClick={this.clearFilter}
                    >
                      Clear
                    </Button>
                    
                  <Tooltip title={ui.tooltip}>
                    <Box
                      onClick={() =>
                        ui.clickable && this.handleIconClick()
                      }
                      sx={{
                        ml: { xs: 0, sm: "auto" },
                        cursor: ui.clickable ? "pointer" : "default",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <Badge
                        badgeContent={count}
                        color={ui.badgeColor}
                        overlap="circular"
                        max={99}
                      >
                        {/* <sirenStrobeIcon
                          className={ui.animationClass}
                          sx={{
                            fontSize: 32,
                            color: ui.color,
                          }}
                        /> */}
                        <Box
                          component="img"
                          src={ui.icon}                 //  conditional icon here
                          alt="Alert siren"
                          className={ui.animationClass}
                          sx={{
                            width: 48,
                            height: 44,
                          }}
                        />
                      </Badge>
                    </Box>
                  </Tooltip>
                  </Box>

                  {/* Main Content Section */}
                  <Box sx={{ display: "flex", gap: { xs: 2, md: 5 }, width: "100%", minWidth: 0, flexDirection: { xs: "column", md: "row" }, }}>
                    {/* Left Side - Video, Buttons, and Alert Info  */}
                    {(this.state.selectedVideoUrl || this.state.selectedAlert) && (
                      <Box sx={{ flex: { xs: "1 1 100%", md: "2" }, display: "flex", flexDirection: "column", height: { xs: 'auto', md: "90vh" }, width: '100%', minWidth: 0, border: "2px solid #989898", borderRadius:'15px', marginLeft: { xs: 0, md: 2.8 }, marginTop:0.2, overflow: 'hidden' }}>
                        {/* Site, customer, police dept no. */}
                        {(!speaker_permission || speaker_permission === "False") ?
                          <Box>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "4px" }}>
                              <Tooltip title="Add notes" arrow>
                                <EditIcon
                                  sx={{ color: "#5eacfa", cursor: "pointer" }}
                                  onClick={async () => {
                                    const currentAlert = this.state.selectedAlert;
                                    if (!currentAlert?.id) {
                                      alert("Please select an alert (click a camera row) first.");
                                      return;
                                    }

                                    const result = await this.updateAlertNote("", true, currentAlert.id);
                                    const noteHistory = await this.fetchNoteHistory(currentAlert.id); // Fetch note history when fetching the note
                                    if (!result) return;

                                    this.setState({
                                      selectedAlert: currentAlert,
                                      noteText: "",
                                      showNoteDialog: true,
                                      noteDetails: {
                                        siteName: result.site_name || "N/A",
                                        cameraName: result.camera_name || "N/A",
                                        outcome: result.threats || "N/A",
                                      },
                                      noteHistory: noteHistory || [],
                                    });
                                  }}
                                />
                              </Tooltip>
                            </Box>
                          </Box>
                        : <Box sx={{ display: { xs: "grid", sm: "table" }, gridTemplateColumns: '1fr', gap: 1, width: "100%", fontSize: "13px", px: { xs: 1, sm: 0 }, marginLeft: { xs: 0, sm: 0.5 }, overflowWrap: 'anywhere' }}>

                          {/* Row 1 */}
                          <Box sx={{ display: { xs: "contents", sm: "table-row" } }}>
                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 1 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Business Name:
                              </Box>{" "}
                              {this.state.selectedAlert.organisation_name || "—"}
                            </Box>
                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 1 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Site Name:
                              </Box>{" "}
                              {this.state.selectedAlert.site_name || "—"}
                            </Box>

                            

                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 2 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Primary Customer Contact:
                              </Box>{" "}
                              {this.state.selectedAlert.customer_contact || "-"}
                            </Box>
                            {/* Add notes */}
                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, width: "40px" }}>
                              <Tooltip title="Add notes" arrow>
                                <EditIcon
                                  sx={{ color: "#5eacfa", cursor: "pointer" }}
                                  onClick={async () => {
                                    const currentAlert = this.state.selectedAlert;
                                    if (!currentAlert?.id) {
                                      alert("Please select an alert (click a camera row) first.");
                                      return;
                                    }

                                    const result = await this.updateAlertNote("", true, currentAlert.id);
                                    const noteHistory = await this.fetchNoteHistory(currentAlert.id); // Fetch note history when fetching the note
                                    if (!result) return;

                                    this.setState({
                                      selectedAlert: currentAlert,
                                      noteText: "",
                                      showNoteDialog: true,
                                      noteDetails: {
                                        siteName: result.site_name || "N/A",
                                        cameraName: result.camera_name || "N/A",
                                        outcome: result.threats || "N/A",
                                      },
                                      noteHistory: noteHistory || [],
                                    });
                                  }}
                                />
                              </Tooltip>
                            </Box>
                          </Box>

                          {/* Row 2 */}
                          <Box sx={{ display: { xs: "contents", sm: "table-row" } }}>
                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 1 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Address:
                              </Box>
                              {this.state.selectedAlert.street_short || "—"} &ensp;
                              <Tooltip title={this.state.selectedAlert.map_link ? "View on map" : "No map link available"} arrow>
                              <PlaceIcon
                                color="error"
                                
                                sx={{ cursor: "pointer", backgroundColor:"#fff",
                                width:20,
                                height:20,
                                }}
                                onClick={() => {
                                  if (this.state.selectedAlert.map_link) {
                                    window.open(this.state.selectedAlert.map_link, "_blank");
                                  }
                                }}
                              />
                              </Tooltip>
                            </Box>

                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 2 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Police Dept No:
                              </Box>{" "}
                              {this.state.selectedAlert.police_department_contact || "-"}
                            </Box>

                            <Box sx={{ display: { xs: "block", sm: "table-cell" }, paddingRight: 1 }}>
                              <Box component="span" sx={{ color: "#91c5f9", fontWeight: 500 }}>
                                Secondary Customer Contact:
                              </Box>{" "}
                              {"—"}
                            </Box>

                            <Box sx={{ display: { xs: "none", sm: "table-cell" } }}>
                              {" "}
                            </Box>
                          </Box>

                          </Box>
                        }
                        
                        <Box sx={{
                            flex: 2,
                            flexGrow: 8,
                            backgroundColor: "#2a303c",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius:'15px',
                            position: "relative", // important for absolute children
                            minHeight: { xs: 'auto', sm: "370px" },
                            maxHeight: { xs: 'none', md: "80vh" },
                            padding: "5px 0px 5px 0px",
                          
                          }}
                        >
                          
                          <Box 
                            sx={{ 
                            border: "6px solid #547ca2",
                            borderRadius:'20px',
                            boxShadow: "0 4px 12px rgba(62, 142, 218, 0.4)",
                            width: '100%',
                            maxWidth: '752px',
                            }}
                          > 
                          
                          {this.state.selectedVideoUrl && (
                            <Box
                              sx={{
                                  // position: "relative",
                                  // mt: 0.5,
                                  width: "100%",
                                  maxWidth: { xs: "100%", md: "740px" },
                                  aspectRatio: "16 / 9", // Ensures consistent height based on width
                                  backgroundColor: "#000",
                                  borderRadius: "20px 20px 0px 0px",
                                  overflow: "hidden",
                              }}
                            >
                            
                              {/* Video Player */}
                              <video
                                ref={this.videoRef}
                                controls
                                autoPlay
                                loop
                                muted
                                playsInline
                                crossOrigin="anonymous"
                                preload="auto"
                                onError={(e) => console.error("❌ Video load error:", e)}
                                onPlay={() => console.log("🎥 Video started")}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  backgroundColor: "black"
                                }}
                              >
                            <source src={this.state.selectedVideoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                              </video>

                            </Box>
                          )}

                          {/* ===== PROFESSIONAL AUDIO CONTROL PANEL ===== */}
                        
                          
                          {/* Rating Buttons Section */}
                          <Box sx={{ margin: { xs: '6px', sm: '10px' } }}>
                            <Box sx={{ flexGrow: 0.2, display: "flex", flexWrap: { xs: 'wrap', md: 'nowrap' }, gap: { xs: 1, md: 4 }, justifyContent: "center", border: "1px solid #5b88b3",
                              borderRadius:'20px', padding: "12px",
                              boxShadow: "0 2px 10px rgba(62, 142, 218, 0.4)"}}>
                              
                              <Button
                                variant={this.getVariant("trueThreat")}
                                color="error"
                                onClick={() => {
                                  this.setState({ selectedRating: "trueThreat" });
                                  this.updateThreatStatus(true);
                                }}
                                size="large"
                                sx={{
                                  padding: "10px",
                                  width: { xs: '100%', sm: "180px" },
                                  backgroundColor:
                                    this.state.selectedRating === "trueThreat" ? "#a92633" : "",
                                  border: "4px solid #a92633",
                                  color:
                                    this.state.selectedRating === "trueThreat" ? "#000" : "white",
                                  "&:hover": {
                                    backgroundColor: "#d02f40",
                                    color: "white",
                                    // borderColor: "#ee263a",
                                  },
                                  
                                }}
                              >
                                <GppMaybeIcon sx={{ fontSize: 28, color: "white" }} />
                                <b style={{fontSize: "16px"}}>Threat </b>
                              </Button>

                              <Button
                                variant={this.getVariant("trueNonThreat")}
                                color="success"
                                onClick={() => {
                                  this.setState({ selectedRating: "trueNonThreat" });
                                  this.updateThreatStatus("trueNonThreat");
                                }}
                                sx={{
                                  backgroundColor: this.state.selectedRating === "trueNonThreat" ? "#3fbc5c" : "",
                                  color: this.state.selectedRating === "trueNonThreat" ? "#000" : "white",
                                  padding: "12px",
                                  width: { xs: '100%', sm: "180px" },
                                  border: "4px solid #72f290",
                                  "&:hover": {
                                    backgroundColor: "#3fbc5c",
                                    color: "white",
                                    // borderColor: "#50c66b",
                                  },
                                }}
                              >
                                <CheckCircleIcon sx={{ fontSize: 28, color: "white" }} />
                                <b style={{fontSize: "16px"}} >Clear</b>
                              </Button>
                              
                              <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', width: { xs: '100%', sm: 'auto' }}}>
                              <Button
                                variant={this.getVariant("false")}
                                color="warning"
                                onClick={() => {
                                  this.setState({ selectedRating: "false" });
                                  this.updateThreatStatus("false");
                                }}
                                sx={{
                                  backgroundColor: this.state.selectedRating === "false" ? "#f4b746" : "",
                                  color: this.state.selectedRating === "false" ? "#000" : "white",
                                  border: "4px solid #f4b746",
                                  // padding: "12px",
                                  width: { xs: '100%', sm: "180px" },
                                  "&:hover": {
                                    backgroundColor: "#eb9e11",
                                    color: "white",
                                    // borderColor: "#cbcbcb",
                                  },
                                  fontSize: "16px",
                                }}
                              >
                                <b>False</b>
                              </Button>
                              
                              {/* {storedUserType === "TechnicianUser" && ( */}
                                <>
                                <Box
                                  sx={{
                                    // backgroundColor: "#282828",
                                    // px: 1,
                                    display: "flex-start",
                                    justifyContent: "space-between",
                                    // alignItems: "center",
                                  
                                    marginTop:'5px'
                                  }}
                                >
                                  {/* LEFT: CONTROL ICONS */}
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                    {/* START ICON */}
                                    <Button
                                      // onClick={this.handlePowerToggle}
                                      disabled={!speaker_permission || speaker_permission === "False"}
                                      sx={{
                                        backgroundColor: (!speaker_permission || speaker_permission === "False") ? "#3c4953" : this.state.audioEnabled ? "#3d9a68" : "#2274b7",
                                        color: "#fff",
                                        width: "75px",
                                        minWidth: "75px",
                                        // height: 30,
                                        // padding: "9px 6px",
                                        // padding: "10px",
                                        boxShadow: this.state.audioEnabled
                                          ? "0 0 10px #3d9a68"
                                          : "none",
                                        "&:hover": {
                                          backgroundColor: this.state.audioEnabled ? "#2e7d52" : "#2274b7"
                                        }
                                      }}
                                    >
                                      <Tooltip title={this.state.audioEnabled ? "Stop Voice chat" : "Start Voice chat"}>
                                        <MicIcon />
                                      </Tooltip>
                                    </Button>

                                    {/* SPEAKER ICON */}
                                    <Box sx={{ position: "relative" }}>
                                      <Button
                                        onClick={() => this.handlePowerToggle(this.state.selectedAlert.gas_paging_devices?.[0])}
                                        disabled={!speaker_permission || speaker_permission === "False"}
                                        sx={{
                                          backgroundColor: (!speaker_permission || speaker_permission === "False") ? "#3c4953" :this.state.audioEnabled ? "#3d9a68" : "#2274b7",
                                          color: "#fff",
                                          transition: "0.3s",
                                          width: "75px",
                                          minWidth: "75px",
                                          // padding: "9px 6px ",
                                          boxShadow: this.state.audioEnabled
                                            ? "0 0 10px #3d9a68"
                                            : "none",
                                          "&:hover": {
                                          backgroundColor: this.state.audioEnabled ? "#2e7d52" : "#2274b7"
                                        }
                                        }}
                                      >
                                        <Tooltip title={this.state.audioEnabled ? "Stop Voice chat" : "Start Voice chat"}>
                                          <VolumeUpIcon />
                                        </Tooltip>
                                      </Button>

                                      {/* BLINKING DOTS */}
                                      {this.state.isAudioPlaying && (
                                        <>
                                          <Box
                                            sx={{
                                              position: "absolute",
                                              top: 2,
                                              right: 1,
                                              width: 7,
                                              height: 7,
                                              borderRadius: "50%",
                                              backgroundColor: "#e8ff8b",
                                              animation: "blink 1s infinite",
                                            }}
                                          />
                                          <Box
                                            sx={{
                                              position: "absolute",
                                              top: 2,
                                              right: 10,
                                              width: 7,
                                              height: 7,
                                              borderRadius: "50%",
                                              backgroundColor: "#e8ff8b",
                                              animation: "blink 1s infinite",
                                              animationDelay: "0.3s",
                                            }}
                                          />
                                        </>
                                      )}
                                      
                                    </Box>
                                      <Tooltip title={"Site Broadcast & Intercom"} arrow>
                                                      {/* <span style={{ marginLeft: "2px", verticalAlign: "middle", color: "#fff" }}> */}
                                                        <InfoOutlinedIcon fontSize="inherit" color="#fff" verticalAlign="middle" />
                                                      {/* </span> */}
                                      </Tooltip>
                                    
                                  </Box>

                                  
                                </Box>
                                <audio
                                  ref={this.audioRef}
                                  src={this.state.selectedAudio}
                                  onEnded={() => this.setState({ isAudioPlaying: false })}
                                />
                                </>
                            {/* )} */}
                            </Box>
                            </Box>
                          </Box>
                          </Box>
                          
                        </Box>
                        {/* live stream and download button section */}
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: 'wrap',
                              gap: 1,
                              justifyContent: "space-between",
                              alignItems: "center",
                              p: { xs: 1, sm: 0 },
                              }}
                          >
                          {/* View Live Stream Button - Bottom Right */}
                          <Button
                              variant="contained"
                              // color="#1b3147"
                              sx={{backgroundColor:"#41658a", color:"#fff"}}
                              onClick={this.handleDownloadVideo}
                          >
                              Download Video
                          </Button>
                          {this.isFilterInactive() && (
                              <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:'2px', border:'1px solid gray', borderRadius:'5px', flex: { xs: '1 1 auto', sm: '0 0 auto' } }}>
                                <Select
                                  value={this.state.selectedSnoozeMinutes}
                                  onChange={(e) => this.setState({ selectedSnoozeMinutes: e.target.value })}
                                  size="small"
                                  sx={{height: 30, padding: "5px" }}
                                >
                                  <MenuItem sx={{ width: 90 }} value={0}>0 min</MenuItem>
                                  <MenuItem sx={{ width: 90 }} value={5}>5 min</MenuItem>
                                  <MenuItem sx={{ width: 90 }} value={10}>10 min</MenuItem>
                                  <MenuItem sx={{ width: 90 }} value={15}>15 min</MenuItem>
                                  <MenuItem sx={{ width: 90 }} value={20}>20 min</MenuItem>
                                  {/* <MenuItem value={60}>1 hour</MenuItem> */}
                                </Select>
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={this.handleSnoozeCamera}
                                    
                                    disabled={
                                      this.state.snoozeTimers &&
                                      this.state.snoozeTimers[this.state.selectedAlert?.camera_id]
                                    }

                                    sx={{
                                      opacity:
                                        this.state.snoozedCameraId === this.state.selectedAlert?.camera_id
                                          ? 0.5
                                          : 1,
                                      pointerEvents:
                                        this.state.snoozedCameraId === this.state.selectedAlert?.camera_id
                                          ? "none"
                                          : "auto",
                                          padding: "8px",
                                    }}
                                >
                                    Snooze
                                </Button>
                              
                                {/* support showing TIMER for camera(s) */}
                                {this.state.snoozeTimers &&
                                  this.state.snoozeTimers[this.state.selectedAlert?.camera_id] && (
                                    <span style={{ marginLeft: 2, marginRight: 3, fontWeight: "bold", color: "red" }}>
                                      {this.state.snoozeTimers[this.state.selectedAlert?.camera_id]}
                                    </span>
                                )}
                              </Box>
                            )}
                          {/* RIGHT: AUDIO SELECT + PLAY */}
                            {/* {this.state.audioEnabled && ( */}
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: { xs: '1 1 100%', sm: '0 1 auto' }, minWidth: 0 }}>

                                {/* Dropdown */}
                                <FormControl size="small" sx={{ minWidth: 0, flex: 1, width: { xs: '100%', sm: 180 } }}>
                                  <Select
                                    value={this.state.selectedAudio}
                                    displayEmpty
                                    onChange={(e) =>
                                      this.setState({ selectedAudio: e.target.value })
                                    }
                                    sx={{
                                      backgroundColor: "#1e1e1e",
                                      color: "#fff",
                                      borderRadius: "8px",
                                      padding: "2px 2px",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#547ca2",
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#3d9a68",
                                      },
                                      fontSize: "14px",
                                    }}
                                  >
                                    <MenuItem value="" disabled sx={{fontSize: "14px"}}>
                                      Audio Message File
                                    </MenuItem>

                                    {this.state.audioList.map((audio, index) => (
                                      <MenuItem key={index} value={audio.id} sx={{fontSize: "14px"}}>
                                        {audio.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                {/* Play Button */}
                                {this.state.selectedAudio && (
                                  <IconButton
                                    variant="contained"
                                    onClick={this.handleAudioPlayPause}
                                    sx={{
                                      color: "#fff",
                                      backgroundColor: this.state.isAudioPlaying ? "#a71414" : "#3d9a68",
                                      "&:hover": { backgroundColor: this.state.isAudioPlaying ? "#9f0b0b" : "#2f915d" },
                                    }}
                                    disabled = {!this.state.audioEnabled}
                                  >
                                    {this.state.isAudioPlaying ? <PauseCircleFilledIcon /> : <PlayCircleFilledWhiteIcon />}
                                  </IconButton>
                                )}
                              </Box>
                            {/* )} */}
                          <Button
                              variant="contained"
                              // color="success"
                              sx={{backgroundColor:"#3d9a68", color:"#fff"}}
                              onClick={() => this.handleCameraClick(this.state.selectedAlert)}
                              disabled={(this.state.selectedAlert.device_status === 'inactive' || this.state.selectedAlert.device_api_status === 'inactive') }
                            >
                              View Live Stream
                          </Button>
                          </Box>
                      </Box>
                    )}
                    {/* <Box sx={{ flex: 1}}></Box> */}
                    {/* Right Side - Alerts Table */}
                    <Box sx={{ flex: { xs: "1 1 100%", md: "1" }, width: "100%", minWidth: 0 }}>
                      <Box component={Paper}
                      sx={{
                        minHeight: { xs: 'auto', md: "90vh" },
                        maxHeight: { xs: 'none', md: "90vh" },
                        border: "2px solid #a3a3a3",
                        borderRadius: "15px",
                        marginRight: { xs: 0, md: "20px" },
                        marginTop: "0.2px",
                        // mb: "10px",
                      }}>
                        {/* {!this.state.showFilterDropdowns && ( */}
                        {(alertsToShow.length > 0 || this.state.whatTimeAgo !== null) && (
                        <p style={{textAlign:'center', color:'orange', fontSize: '14.5px', fontWeight: 'bold'}}> Last alert received {this.state.whatTimeAgo || '-'} ago </p>
                        )}
                        {/* )} */}

                            <TableContainer
                            component={Paper}
                            sx={{
                              backgroundColor: "#121212",
                              border: "4px solid #547ca2",
                              borderRadius: "15px",
                              boxShadow: "0 4px 12px rgba(62, 142, 218, 0.4)",
                              maxWidth: '100%',
                              overflowX: 'hidden',
                            }}
                          >
                              {this.state.isRefreshing && (
                                <Box display="flex" alignItems="center" gap={1} mt={2} mb={1}>
                                  <CircularProgress size={18} color="primary" />
                                  <Typography variant="caption" color="textSecondary">
                                    Refreshing...
                                  </Typography>
                                </Box>
                              )}
                            {/* Filter By Resolve Status and Detection Type */}
                            <TableContainer  sx={{ overflowY: "auto", borderRadius: 2 }}>
                              <Table stickyHeader size="small">
                              <TableHead >
                              {this.state.showFilterDropdowns && (
                                <TableRow
                                  sx={{
                                    backgroundColor: "#121212",
                                    "& th": {
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: "#333",
                                        borderBottom: "1px solid #ccc",
                                        paddingY: 1,
                                        paddingX: 2,
                                    }
                                }}>
                                  <TableCell
                                    colSpan={5}
                                    sx={{
                                      position: 'sticky',
                                      top: 0,
                                      zIndex: 2,
                                      backgroundColor: '#121212',
                                      px: 2,
                                      py: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 1,
                                        justifyContent: 'space-between', // ⬅️ ensures left/right split
                                        alignItems: 'center',
                                        width: '100%',
                                      }}
                                    >
                                      {/* FILTER BY - left */}
                                      <Box>
                                        <span style={{ fontWeight: 600, fontSize: '13px', marginRight: 4, color:'#f2f2f283' }}>FILTER BY:</span>
                                        <Button
                                          size="small"
                                          onClick={this.handleResolveClick}
                                          endIcon={<ArrowDropDownIcon />}
                                          sx={{
                                            fontSize: '13px',
                                            textTransform: 'capitalize',
                                            color: '#1976d2',
                                            fontWeight: 'bold',
                                            padding: 0,
                                            minWidth: 'unset',
                                          }}
                                        >
                                          {this.state.resolveStatus} Alerts
                                        </Button>
                                        <Menu
                                          anchorEl={this.state.anchorElResolve}
                                          open={Boolean(this.state.anchorElResolve)}
                                          onClose={this.handleResolveClose}
                                          MenuListProps={{ dense: true }}
                                        >
                                          {['All', 'Resolved', 'Unresolved'].map((opt) => (
                                            <MenuItem
                                              key={opt}
                                              selected={this.state.resolveStatus === opt}
                                              onClick={() => this.handleResolveSelect(opt)}
                                            >
                                              {opt} Alerts
                                            </MenuItem>
                                          ))}
                                        </Menu>
                                      </Box>

                                      {/* DETECTION TYPE - right */}
                                      <Box>
                                        <span style={{ fontWeight: 600, fontSize: '13px', marginRight: 4, color:'#f2f2f283' }}>FILTER TYPE:</span>
                                        <Button
                                          size="small"
                                          onClick={this.handleDetectionClick}
                                          endIcon={<ArrowDropDownIcon />}
                                          sx={{
                                            fontSize: '13px',
                                            textTransform: 'capitalize',
                                            color: '#1976d2',
                                            fontWeight: 'bold',
                                            padding: 0,
                                            minWidth: 'unset',
                                          }}
                                        >
                                          {this.state.selectedRatingOption
                                            ? this.state.selectedRatingOption === 'trueThreat'
                                              ? 'Threat'
                                              : this.state.selectedRatingOption === 'trueNonThreat'
                                              ? 'Clear'
                                              : 'False'
                                            : this.state.detectionType}
                                        </Button>
                                        <Menu
                                          anchorEl={this.state.anchorElDetection}
                                          open={Boolean(this.state.anchorElDetection)}
                                          onClose={this.handleDetectionClose}
                                          MenuListProps={{ dense: true }}
                                        >
                                          {['All', 'Bike', 'Car', 'Person','Threat', 'Clear', 'False'].map((opt) => (
                                            <MenuItem
                                              key={opt}
                                              selected={this.state.detectionType === opt}
                                              onClick={() => this.handleDetectionSelect(opt)}
                                            >
                                              {opt}
                                            </MenuItem>
                                          ))}
                                        </Menu>
                                      </Box>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              )}
                              </TableHead>
                              </Table>
                            </TableContainer>
                            {/* Alert record cards */}
                            <Box
                              sx={{
                                overflowY: 'auto',
                                "&::-webkit-scrollbar": { width: "10px" },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#0239b0",
                                  borderRadius: "8px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor: "#bed8ff", // 👈 track color
                                  borderRadius: "8px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  backgroundColor: "#0260be", // optional hover effect
                                },
                                maxHeight: { xs: '65vh', md: '68vh' },
                                minHeight: 100,
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                              }}
                            >
                              
                              <div className="grid-container-alert-table-records">
                                { alertsToShow.length > 0 ?
                                  alertsToShow.map((alert, idx) => (
                                      <Box 
                                        key={alert.id}
                                        className="alert-table-records-card"
                                        sx={{
                                          backgroundColor: (String(alert.threats).toLowerCase() === "true") ? "#ffaeae" : (String(alert.threats).toLowerCase() === "truenonthreat") ? "#c5ffc6": (String(alert.threats).toLowerCase() === "false") ? "#fffbc6": this.state.selectedAlertId === (alert.id || idx) ? "#c6eaff" : "#f0f0f0", // 🔷 highlight selected
                                          border: this.state.selectedAlertId === (alert.id || idx) ? "4px solid #1976d2a2" : "none", // optional visual marker
                                          transition: "all 0.3s ease",
                                          
                                          // "&:hover": {
                                          //     backgroundColor: "#9a9a9a",
                                          // },
                                          cursor: alert.presigned_url ? 'pointer' : 'default',
                                          }}
                                          onClick={() => {
                                            if (alert.presigned_url) {
                                              console.log(`🎥 Playing video for Camera ${alert.camera_id}, Alert ID: ${alert.id || idx}`);
                                              
                                              // Normalize the threat value
                                              let threatValue = String(alert.threats).toLowerCase();
                                              let selectedRating = ""; // default

                                              if (threatValue === "true") {
                                                selectedRating = "trueThreat";
                                              } else if (threatValue === "truenonthreat") {
                                                selectedRating = "trueNonThreat";
                                              }
                                              else if (threatValue === "false") {
                                                selectedRating = "false";
                                              }

                                              this.setState({
                                                selectedVideoUrl: alert.presigned_url,
                                                showLiveStream: false,
                                                selectedAlertId: alert.id || idx,
                                                selectedAlert: alert,
                                                selectedRating: selectedRating,
                                                }, async () => {
                                                    // !this.state.showFilterDropdowns && this.updateThreatStatus("trueNonThreat"); // default to "Clear" when opening a new alert
                                                    // const history = await this.fetchNoteHistory(alert.id);
                                                    // console.log("Fetched Note History:", history);
                                                    // this.setState({ noteHistory: history || [] });

                                                    // 2. Check if the alert is already resolved (has a threat status)
                                                const threatStatus = alert.threats ? String(alert.threats).toLowerCase() : "";
                                                const isResolved = threatStatus === "true" || threatStatus === "truenonthreat" || threatStatus === "false";

                                                // 3. Only mark as clear ('trueNonThreat') if it is NOT resolved and filter dropdowns aren't open
                                                if (!isResolved && !this.state.showFilterDropdowns) {
                                                  console.log("Alert is unresolved. Marking as clear...");
                                                  this.updateThreatStatus("trueNonThreat");
                                                } else {
                                                  console.log("Alert is already resolved. Just loaded details.");
                                                }
                                              });
                                            }
                                          }}
                                        >
                                          {/* Icons for detected objects */}
                                          <span>
                                            {(() => {
                                              let objects = alert.detected_objects;

                                              if (typeof objects === 'string') {
                                                try {
                                                  objects = JSON.parse(objects);
                                                } catch (e) {
                                                  return "—";
                                                }
                                              }

                                              if (Array.isArray(objects) && objects.length > 0) {
                                                return (
                                                  <span style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                                    {objects.map((obj, index) => {
                                                      const key = obj.toLowerCase();
                                                      const IconComponent = objectIconMap[key];

                                                      return IconComponent ? (
                                                        <IconComponent
                                                          key={index}
                                                          titleAccess={obj}
                                                          sx={{
                                                            fontSize: 40,
                                                            // backgroundColor:
                                                            //   this.state.detectionTypeColors[
                                                            //     obj.charAt(0).toUpperCase() + obj.slice(1)
                                                            //   ] || "#90caf9",
                                                              backgroundColor:"#d32323bf",
                                                              color: "#fff",
                                                              borderRadius: "50%",
                                                              padding: "2px",
                                                          }}
                                                        />
                                                      ) : (
                                                        <span key={index}>{obj}</span> // fallback if unknown object
                                                      );
                                                    })}
                                                  </span>
                                                );
                                              }

                                              return <span style={{ color: "#999", fontStyle: "italic" }}>—</span>;
                                            })()}
                                          </span>
                                          {/* camera, device name and time section */}
                                          <span>
                                            {/*camera_name*/}
                                            <Box display="inline-flex" alignItems="center" gap={0.5} fontWeight={550}>
                                              {alert.presigned_url && 
                                                <span style={{ fontSize: 16 }}>
                                                  <img
                                                    src={DeviceIcon}
                                                    alt="device-icon"
                                                    width="20px"
                                                  /> 
                                                </span>
                                              }
                                              {alert.device_name || alert.device_id || '—'} {":- "} {alert.camera_name || `Camera ${alert.camera_id}`}
                                            </Box>
                                            {/*device name*/}
                                            {/* <p style={{ marginTop: 0.1, marginBottom: 0}}>{alert.device_name || alert.device_id || '—'}</p> */}
                                            {/*alert received at*/}
                                            <p style={{ marginTop: 0, marginBottom: 0}}>
                                              {(() => {
                                                const parts = alert.site_timestamp.split(" ");
                                                const dateTime = `${parts[0]}T${parts[1]}`;
                                                const timezone = parts[2] || "";
                                                const formattedDate = new Date(dateTime).toLocaleString("en-US", {
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  year: "numeric",
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  second: "2-digit",
                                                  hour12: true, // 👈 AM/PM format
                                                });

                                                return (
                                                  <span style={{display:'flex', justifyContent:'center'}}>
                                                    <SouthEastIcon color="error" sx={{width:"12px"}} />
                                                    {/* {new Date(dateTime).toLocaleString()} */}
                                                    {formattedDate}
                                                    <Tooltip title={timezone} arrow>
                                                      <span style={{ marginLeft: "2px", verticalAlign: "middle", color: "#000" }}>
                                                        <InfoOutlinedIcon fontSize="inherit" />
                                                      </span>
                                                    </Tooltip>
                                                  </span>
                                                );
                                              })()}
                                          </p>
                                          </span>
                                          <span>
                                            {/* user name */}
                                            <p style={{ marginBottom: 0}}>
                                              {alert.history?.updated_by || ''}
                                            </p>
                                            {/* date of resolved alert */}
                                            <p style={{ marginTop: 0}}>
                                              {(() => {
                                                const raw =
                                                  alert.history?.updated_at || "";

                                                if (!raw) return "";

                                                const date = new Date(raw);

                                                const formattedDateTime = date.toLocaleString("en-US", {
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  year: "numeric",
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  second: "2-digit",
                                                  hour12: true,
                                                });

                                                const timezone = date.toLocaleString("en-US", {
                                                  timeZoneName: "short",
                                                }).split(" ").pop(); // e.g., IST

                                                return (
                                                  <span style={{display:'flex', justifyContent:'center'}}>
                                                    <DownloadDoneIcon color="success" sx={{width:"14px"}} />
                                                    {formattedDateTime}{" "}
                                                    <Tooltip title={`${timezone}`} arrow>
                                                      <span style={{ marginLeft: "2px", verticalAlign: "middle", color: "#000" }}>
                                                        <InfoOutlinedIcon fontSize="inherit" style={{ cursor: "pointer" }} />
                                                      </span>
                                                    </Tooltip>
                                                  </span>
                                                );
                                              })()}
                                            </p>
                                          </span>
                                          {/* operator rating icons */}
                                          <span>
                                            {(() => {
                                              const rawThreat = alert.threats;

                                              const threatVal = rawThreat !== null && rawThreat !== undefined
                                                ? String(rawThreat).trim().toLowerCase()
                                                : "";

                                              // ✅ Check unresolved FIRST
                                              if (
                                                rawThreat === null ||
                                                rawThreat === undefined ||
                                                threatVal === "null" ||
                                                threatVal === ""
                                              ) {
                                                return ""; // unresolved
                                              }

                                              if (threatVal === "true") {
                                                return (
                                                  <Tooltip title="True Threat">
                                                    <CheckCircleIcon color="error" sx={{fontSize:30}} />
                                                  </Tooltip>
                                                );
                                              }

                                              if (threatVal === "truenonthreat") {
                                                return (
                                                  <Tooltip title="True Non-threat">
                                                    <CheckCircleIcon color="success" sx={{fontSize:30}} />
                                                  </Tooltip>
                                                );
                                              }

                                              if (threatVal === "false") {
                                                return (
                                                  <Tooltip title="False Alert">
                                                    <CancelIcon color="warning" sx={{fontSize:30}}/>
                                                  </Tooltip>
                                                );
                                              }

                                              return ""; // fallback for unexpected value
                                            })()}
                                          </span>
                                      </Box>
                                ))
                                :(
                                    <p style={{textAlign:'center'}}>No alerts to display.</p>
                                )}
                              </div>
                            </Box>
                        </TableContainer>
                        
                        {/* Alerts pagination */}
                        <Box
                          sx={{
                            position: 'sticky',
                            bottom: 0,
                            backgroundColor: '#313131',
                            zIndex: 3,
                            padding: '2px 8px',
                            borderTop: '1px solid #ccc',
                            display: 'flex',
                            flexWrap: { xs: 'wrap', sm: 'nowrap' },
                            gap: { xs: 0.5, sm: 0 },
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Button
                            onClick={this.handlePrevPage} // moved logic to handler function to include auto-refresh restriction
                            disabled={this.state.videoAlertPage <= 1}
                          >
                            Previous
                          </Button>

                          <Box display="flex" alignItems="center" gap={1}>
                            <Tooltip title={autoRefreshMessage}>
                              <Box
                                onClick={() => {
                                  if (!disableAutoToggle) {
                                    this.setState({ autoRefreshEnabled: !this.state.autoRefreshEnabled });
                                  }
                                }}
                                sx={{
                                  cursor: disableAutoToggle ? "not-allowed" : "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  color: this.state.autoRefreshEnabled ? "primary.main" : "error.main",
                                  opacity: disableAutoToggle ? 0.5 : 1,
                                }}
                              >
                                {this.state.autoRefreshEnabled ? (
                                  <AutorenewIcon sx={{ animation: 'spin 2s linear infinite' }} />
                                ) : (
                                  <BlockIcon />
                                )}
                              </Box>
                            </Tooltip>
                          </Box>
                          
                            {/* 📘 Page display with icon */}
                          {/* <Box display="flex" alignItems="center" gap={1}>
                            <LibraryBooksOutlinedIcon sx={{ fontSize: 18, color: '#1976d2' }} />
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {this.state.videoAlertPage} / {this.state.videoAlertTotalPages}
                            </Typography>
                          </Box> */}

                          <Box display="flex" alignItems="center" gap={1} sx={{ order: { xs: 3, sm: 0 }, flex: { xs: '1 1 100%', sm: '0 0 auto' }, justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                              <Typography variant="body2">Rows/Page</Typography>
                              <FormControl size="small" sx={{ minWidth: 80 }}>
                                <Select
                                  value={this.state.pageSize}
                                  onChange={(e) => {
                                    const newSize = parseInt(e.target.value, 10);
                                    this.setState(
                                      { pageSize: newSize, videoAlertPage: 1 },
                                      () => this.apiFilteredAlerts(1)
                                    );
                                  }}
                                >
                                  {[25, 50, 100].map((size) => (
                                    <MenuItem key={size} value={size}>{size}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Box display="flex" alignItems="center" gap={0.5} sx={{ ml: { xs: 1, sm: 3 } }}>
                          <LibraryBooksOutlinedIcon sx={{ color: '#1976d2', fontSize: 18 }} />
                          <Typography variant="body2" sx={{ fontWeight: 500, color: '#ffffff' }}>
                            {start}–{end} of {totalAlertCount}
                          </Typography>
                        </Box>
                          </Box>


                          <Button
                            onClick={this.handleNextPage} // moved logic to handler function to include auto-refresh restriction
                            disabled={this.state.videoAlertPage >= this.state.videoAlertTotalPages}
                          >
                            Next
                          </Button>
                        </Box>
                        {!this.state.showFilterDropdowns && (
                          <p style={{textAlign:'center', color:'orange', fontSize: '14.5px', fontWeight: 'bold'}}> Last one hour records are shown by default</p>
                        )}
                      </Box>

                    {/* Optional selected video display (kept as-is) */}
                    {this.state.selectedVideoUrl  && (
                        <Box sx={{ mt: 2 }}>
                          {/* 
                              <video
                              src={this.state.selectedVideoUrl}
                              autoPlay
                              controls
                              muted
                              playsInline
                              style={{ width: '100%', maxHeight: '400px', borderRadius: '8px' }}
                          > 
                              Your browser does not support the video tag.
                              </video> 
                          */}
                        </Box>
                    )}
                  </Box>
                      
                      
                  </Box>
                </Box>
                <div style={{ marginTop: '2px', display: 'flex', justifyContent: 'center', marginBottom: '3cm', alignItems: 'center' }}>
                
                  <Snackbar
                    open={this.state.open_snackbar}
                    autoHideDuration={5500}
                    onClose={this.handleSnackbarClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    sx={{
                      bottom: "50px",
                      zIndex: 9999,
                    }}
                  >
                    <Alert
                      onClose={this.handleSnackbarClose}
                      variant="filled"
                      elevation={6}
                      severity={this.state.alert_type}
                      sx={{ whiteSpace: "pre-line" }}
                    >
                      {this.state.snackbar_msg}
                    </Alert>
                  </Snackbar>
                </div>
                
                {this.state.showLiveStream && (
                    <Box
                      // ref={(ref) => (this.liveStreamRef = ref)}
                      ref={this.liveStreamRef}
                      sx={{
                          position: 'fixed',
                          top: this.state.isFullScreen ? 0 : { xs: 8, sm: (this.state.liveStreamBoxTop || '90px') },
                          left: this.state.isFullScreen ? 0 : { xs: 8, sm: (this.state.liveStreamBoxLeft || '100px') },
                          width: this.state.isFullScreen ? '100vw' : { xs: 'calc(100vw - 16px)', sm: 'min(850px, calc(100vw - 32px))' },
                          height: this.state.isFullScreen ? '100dvh' : { xs: 'calc(100dvh - 16px)', sm: 'min(650px, calc(100vh - 32px))' },
                          backgroundColor: 'black',
                          zIndex: 2000,
                          display: 'flex',
                          flexDirection: 'column',
                          p: { xs: 1, sm: 2 },
                          borderRadius: this.state.isFullScreen ? 0 : 2,
                          boxShadow: 24,
                          isolation: 'isolate',
                          overflow: 'hidden',
                        
                      }}

                    >
                        {/* Header: Label, Selection Box, Fullscreen/Close Icons */}
                        <Box 
                          sx={{ display: 'flex', flexWrap: { xs: 'wrap', sm: 'nowrap' }, gap: 1, justifyContent: 'space-between', alignItems: 'center', mb: { xs: 1, sm: 2 }, position: 'relative', zIndex: 1500 }}

                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flex: '1 1 auto', minWidth: 0 }}>
                              {/* <Typography variant="h6" color="white">
                                Live Stream
                              </Typography> */}
                              <Box
                                ref={this.dragHandleRef}
                                onMouseDown={this.handleDragStart}
                                sx={{
                                  cursor: { xs: "default", sm: "move" },
                                  padding: "8px",
                                  background: "#222",
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Live Cameras
                              </Box>
                                
                              <FormControl sx={{ minWidth: 0, flex: '1 1 200px', maxWidth: 300 }} size="small" onMouseDown={(e) => e.stopPropagation()}>
                                <InputLabel id="camera-select-label" sx={{ color: 'white' }}>Add Cameras</InputLabel>
                                <Select
                                    labelId="camera-select-label"
                                    multiple
                                    value={this.state.selectedLiveCameras.map(c => c.camera_id)}
                                    onMouseDown={(e) => e.stopPropagation()}
                                    // onClick={(e) => e.stopPropagation()}
                                    onChange={this.handleLiveCameraSelection}
                                    sx={{ 
                                        color: 'white', 
                                        '.MuiOutlinedInput-notchedOutline': { borderColor: 'gray' },
                                        '& .MuiSvgIcon-root': { color: 'white' } // Ensure the dropdown arrow is visible
                                    }}
                                    renderValue={(selected) => `Selected (${selected.length}/6)`}
                                    
                                    // This ensures the dropdown menu is visible over your modal
                                    MenuProps={{
                                      disablePortal: true,
                                      PaperProps: {
                                          sx: {
                                              // bgcolor: '#333', // Dark background for the menu
                                              color: 'white',
                                              // zIndex: 9999, // Higher than your modal's 1400
                                              maxHeight: 300 
                                          }
                                      }
                                    }}
                                >
                                    {this.state.fetchedCamerasList && this.state.fetchedCamerasList.length > 0 ? (
                                        this.state.fetchedCamerasList.map((cam) => (
                                            <MenuItem 
                                                key={cam.camera_id} 
                                                value={cam.camera_id}
                                                sx={{
                                                    '&.Mui-selected': { bgcolor: '#43566d' },
                                                }}
                                            >
                                              <Checkbox
                                                // checked={this.state.selectedLiveCameras
                                                //   .map(c => c.camera_id)
                                                //   .includes(cam.camera_id)}
                                                  checked={this.state.selectedLiveCameras
                                                  .map(c => String(c.camera_id))
                                                  .includes(String(cam.camera_id))}
                                                sx={{ color: 'blue' }}
                                              />
                                                {cam.camera_name}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem disabled>No cameras found</MenuItem>
                                    )}
                                </Select>
                              </FormControl>
                            
                            </Box>

                            <Box sx={{display:'flex', gap:'3px'}}>
                                {this.state.focusedCamera && (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.handleExitFocus();
                                    }}
                                    sx={{
                                      
                                      zIndex: 10,
                                      color: 'white'
                                    }}
                                  >
                                    {/* <CancelIcon /> */}
                                    {this.state.focusedCamera ? 
                                      <FullscreenExitIcon /> 
                                      : 
                                      <FullscreenIcon />
                                    }
                                  </IconButton>
                                )}
                                {/* Full Screen Mode Icon */}
                                <IconButton 
                                    onClick={() => this.setState({ isFullScreen: !this.state.isFullScreen })} 
                                    sx={{ color: 'white', mr: 1 }}
                                >
                                    {!this.state.focusedCamera ? ( this.state.isFullScreen ?
                                      <Box
                                      sx={{
                                        padding: "8px",
                                        background: "#222",
                                        fontSize: 16,
                                        fontWeight: 'bold',
                                        color: '#f4f4f4e4',
                                      }}
                                    >
                                      Back
                                    </Box> 
                                      : <StreetviewIcon />):("")} 
                                </IconButton>
                                <IconButton onClick={this.handleCloseLiveStream} sx={{ color: 'white' }}>
                                    <CancelIcon sx={{ color: 'red' }} />
                                </IconButton>
                            </Box>
                        </Box>

                        {/* Live Stream Grid: 2 or 3 in a row */}
                        <Box 
                            sx={{ 
                                display: 'grid', 
                                gridTemplateColumns: { xs: '1fr', sm: this.state.focusedCamera ? '1fr' : this.getGridColumns() },
                                // overflowY: this.state.isFullScreen ? 'auto' : 'hidden',
                                gap: 2, 
                                width: '100%', 
                                height: '100%',
                                // overflowY: 'auto',
                                position: 'relative',
                                overflowY: 'auto',
                                // cursor: 'move',
                                zIndex: 1,
                            }}
                        >
                                                        
                          {(this.state.focusedCamera 
                            ? [this.state.focusedCamera] 
                            : this.state.selectedLiveCameras
                          ).map((cam) => {
                            // Check if this specific camera has thrown a 404/load error
                            const isFailed = this.state.failedStreams[cam.camera_id];

                            return (
                            <Box 
                              key={cam.camera_id} 
                              onDoubleClick={() => this.handleFocusCamera(cam)}
                              sx={{ 
                                backgroundColor: '#1c1c1c', 
                                border: '1px solid #333', 
                                borderRadius: 1, 
                                position: 'relative',
                                height: '100%',
                                // gridAutoRows: 'minmax(0, 1fr)',
                                minHeight: '200px',
                                width: '100%'
                              }}
                            >
                              {isFailed ? (
                              /* Display user-friendly failure message when 404 occurs */
                              <Box sx={{justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100%', width: '100%'}}>
                              <Box sx={{ textAlign: 'center', backgroundColor: 'rgba(211, 47, 47, 0.1)', // Subtle red tint background
                                color: '#d32f2f',  p: 2,}}>
                                  <VideocamOffIcon sx={{ fontSize: 40, mb: 1 }} />
                                  <Typography variant="body2" 
                                    sx={{ 
                                        color: '#aaaaaa', 
                                        maxWidth: '240px',
                                        lineHeight: 1.4,
                                        mb: 2.5
                                    }}>
                                      Stream could not be established
                                  </Typography>
                              </Box>
                              </Box>
                          ) : (
                              
                              <img
                                src={`${urls.SEE_LIVE_STREAM(cam.selectedAlertId)}?viewerId=${viewerId}`} //API changed: now using the static variable from urls/jsx file for the value of domain name of separate live stream server.
                                alt={`Live Stream ${cam.camera_name}`}
                                onError={() => this.handleStreamError(cam.camera_id)}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                              )}
                            </Box>
                          )})}
                                
                        </Box>
                    </Box>
                )}
                <Dialog
                  open={this.state.showNoteDialog}
                  onClose={() => this.setState({ showNoteDialog: false })}
                  fullWidth
                  maxWidth="sm"
                  PaperProps={{ sx: { m: { xs: 1, sm: 4 }, maxHeight: { xs: 'calc(100dvh - 16px)', sm: 'calc(100% - 64px)' } } }}
                >
                  <DialogTitle>Edit Note</DialogTitle>
                  <DialogContent>
                    <Typography variant="body2" gutterBottom><strong>Site:</strong> {this.state.noteDetails.siteName}</Typography>
                    <Typography variant="body2" gutterBottom><strong>Camera:</strong> {this.state.noteDetails.cameraName}</Typography>
                    <Typography variant="body2" gutterBottom><strong>Outcome:</strong> {this.state.noteDetails.outcome}</Typography>

                    <TextField
                      label="Note"
                      multiline
                      rows={4}
                      value={this.state.noteText}
                      onChange={(e) => this.setState({ noteText: e.target.value })}
                      fullWidth
                      margin="normal"
                    />
                  </DialogContent>
                <DialogActions sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                  <Tooltip
                    title={
                      <Box
                    sx={{
                      p: 1,
                      maxWidth: 320,
                      maxHeight: 300,
                      overflowY: 'auto',
                      borderRadius: 2,
                    }}
                  >
                    {this.state.noteHistory?.length > 0 ? (
                      <>
                        {/* Normal history */}
                        {normalHistory.map((entry, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              mb: 1,
                              p: 1.5,
                              borderRadius: 2,
                              backgroundColor: idx % 2 === 0 ? '#2c2c2c' : '#3a3a3a',
                              border: '1px solid #444',
                              color: '#fff',
                            }}
                          >
                            <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: '#90caf9', mb: 1 }}>
                              {idx + 1}.
                            </Typography>

                            <Typography sx={{ fontSize: '13px', color: '#ff6b6b', mb: 0.5 }}>
                              🕘 <strong>Old:</strong> {entry.old_value || '—'}
                            </Typography>

                            <Typography sx={{ fontSize: '13px', color: '#4caf50', mb: 0.5 }}>
                              🆕 <strong>New:</strong> {entry.new_value || '—'}
                            </Typography>

                            <Typography sx={{ fontSize: '13px', color: '#90caf9', mb: 0.5 }}>
                              👤 <strong>By:</strong> {entry.updated_by || '—'}
                            </Typography>

                            <Typography sx={{ fontSize: '13px', color: '#fdd835' }}>
                              📅 <strong>Date:</strong>{' '}
                              {entry.updated_at
                                ? new Date(entry.updated_at).toLocaleString('en-IN')
                                : '—'}
                            </Typography>
                          </Box>
                        ))}

                        {/* Snooze history (separate box) */}
                        {snoozeEntry?.snooze_history?.length > 0 && (
                          <Box
                            sx={{
                              mt: 2,
                              p: 1.5,
                              borderRadius: 2,
                              backgroundColor: '#1e3a3a',
                              border: '1px solid #35fdf0ff',
                            }}
                          >
                            <Typography sx={{ fontSize: '13px', color: '#35fdf0ff', mb: 1 }}>
                              🕘 <strong>Snooze History</strong>
                            </Typography>

                            {snoozeEntry.snooze_history.map((s, i) => (
                              <Typography
                                key={i}
                                sx={{ fontSize: '12px', color: '#d7fffcff', ml: 1 }}
                              >
                                {s.snooze ? 
                                  `• Started by ${s.snooze_user} — ${new Date(s.timestamp).toLocaleString('en-IN')}`
                                : `• Stopped by System — ${new Date(s.timestamp).toLocaleString('en-IN')}`
                                }
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Box
                        sx={{
                          p: 2,
                          border: '1px dashed #ccc',
                          borderRadius: 2,
                          backgroundColor: '#2c2c2c',
                          color: '#607d8b',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '13px',
                          fontWeight: 500,
                          minHeight: '20px',
                        }}
                      >
                        <span role="img" aria-label="note">📭</span>&nbsp; No note history available
                      </Box>
                    )}
                  </Box>
                  }
                    placement="top"
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: 'transparent',
                          p: 0,
                          boxShadow: 'none',
                        },
                      },
                    }}
                  >
                    <IconButton size="small" color="primary">
                      <LibraryBooksOutlinedIcon />
                    </IconButton>
                  </Tooltip>


                      <Button onClick={() => this.setState({ showNoteDialog: false })}>Cancel</Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                          const { noteText, selectedAlert } = this.state;
                          if (!selectedAlert?.id) {
                            alert("No alert selected for note submission.");
                            return;
                          }

                          console.log("📤 Submitting note:", noteText);
                          await this.updateAlertNote(noteText, false, selectedAlert.id); // ✅ Explicitly pass alertId
                        }}
                      >
                        Submit
                      </Button>
                </DialogActions>
                </Dialog>
                <Dialog
                  open={this.state.showNoteHistoryDialog}
                  onClose={() => this.setState({ showNoteHistoryDialog: false })}
                  fullWidth
                  maxWidth="sm"
                  PaperProps={{ sx: { m: { xs: 1, sm: 4 }, maxHeight: { xs: 'calc(100dvh - 16px)', sm: 'calc(100% - 64px)' } } }}
                >
                  <DialogTitle>Note History</DialogTitle>
                  <DialogContent sx={{ maxWidth: 500, px: { xs: 1, sm: 3 } }}>
                    {this.state.noteHistory?.length > 0 ? (
                      <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
                      <Table size="small" sx={{ minWidth: 500 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Old</TableCell>
                            <TableCell>New</TableCell>
                            <TableCell>User</TableCell>
                            <TableCell>Time</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.noteHistory.map((entry, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{entry.old_value || "—"}</TableCell>
                              <TableCell>{entry.new_value || "—"}</TableCell>
                              <TableCell>{entry.updated_by || "—"}</TableCell>
                              <TableCell>
                                {new Date(entry.updated_at).toLocaleString()}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      </TableContainer>
                    ) : (
                      <Typography variant="body2">No note history available.</Typography>
                    )}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => this.setState({ showNoteHistoryDialog: false })}>Close</Button>
                  </DialogActions>
                </Dialog>

                
                {this.state.showWsAlertTable && ( 
                    
                  <div 
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                        zIndex: 999, 
                        display: "flex",
                        justifyContent: "flex-end", 
                        alignItems: "center", // Align vertically
                        }}
                    >
                      <div className='Slide-alert-notification-table'>
                        <button
                            onClick={this.closePopup}
                            style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            background: "white",
                            border: "none",
                            fontSize: "18px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            }}
                          >
                            ✖
                          </button>
                        <p style={{display:'flext',textAlign:'center', alignContent:'center', width:'100%', backgroundColor:'#304e6b', color:'#fff', height:'1.5cm'}}>Alerts List</p>
                        
                  <TableContainer component={Paper} sx={{ mt: 2, zIndex: 1, overflow: 'auto', maxWidth: '100%', maxHeight: { xs: 'calc(100dvh - 100px)', sm: '85vh' }, overscrollBehavior: 'contain' }}>
                    <Table size="small" sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow >
                          <TableCell sx={{fontWeight: 'bold', whiteSpace:'nowrap' }} >Sr. Id</TableCell>
                          <TableCell sx={{fontWeight: 'bold'}} >Device Name</TableCell>
                          {/* <TableCell sx={{fontWeight: 'bold'}} >Camera ID</TableCell> */}
                          <TableCell sx={{fontWeight: 'bold'}} >Camera Name</TableCell>
                          <TableCell sx={{fontWeight: 'bold'}} >Time</TableCell>
                          <TableCell sx={{fontWeight: 'bold'}} >Status</TableCell>
                          <TableCell sx={{fontWeight: 'bold'}} >Log</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {this.state.wsAlerts?.map((alert, index) => (
                          <TableRow key={alert.id}>
                            <TableCell>{index + 1}</TableCell>
                            {/* <TableCell>{alert.nvrId}</TableCell> */}
                            <TableCell>{alert.deviceName}</TableCell>
                            {/* <TableCell>{alert.cameraId}</TableCell> */}
                            <TableCell>{alert.cameraName}</TableCell>
                            <TableCell>
                              {/* {(alert.receivedAt).toLocaleString()} */}
                              {(alert.receivedAt || alert.timeStamp) ?
                              ((new Date(alert.receivedAt).toLocaleString()) || alert.timeStamp) : '—'}
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={(alert.status === "offline" || alert.status === "inactive" || alert.status === "unstable") ? ( alert.status === "unstable" ? "Unstable" : "Offline") : "online"}
//                                   label={
//   (alert.status === "offline" || 
//    alert.status === "inactive" || 
//    alert.status === "unstable")
//     ? (
//         alert.status === "unstable"
//           ? "Unstable"
//           : alert.offline_duration === "-"
//               ? "Offline"
//               : `Offline since ${alert.offline_duration}` alert.error || 
//       )
//     : "Online"
// }
                                color={(alert.status === "offline" || alert.status === "inactive" || alert.status === "unstable") ? "error" : "success"}
                                size="small"
                              />
                            </TableCell>
                            <TableCell>{(alert.error !== "-" ? alert.error : "") + (alert.offline_duration !== "-" ? `${alert.status} since ${alert.offline_duration} (hr:min)`: "")}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </div>
                </div>
                )}
              </div>
              {/* Backdrop with Circular Progress */}
                          <Backdrop open={this.state.open_progress_bar} style={{zIndex:'1600'}}>
                            <div className="custom-spinner">
                                <div className="circle"></div>
                                <div className="circle tilted"></div>
                                <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                            </div>
                           </Backdrop>
            </div>
          </ThemeProvider>
        );
    }
}

export default withNavigate(AlertTab);
